// 2024-10-07T09:50:16.209Z  (1728294616209)
export const locale = {
	lang: 'en',
	data: {
		'ACCOUNTING_VALUE': 'Additional Value',
		'ACCOUNTING_VALUES': 'Additional Values',
		'ACCOUNTING_VALUE.COMPUTE_IN_STATES': 'Computation only in selected workstates',
		'ACCOUNTING_VALUE.VALUE_AGGREGATION': 'Value aggregation',
		'ACCOUNTING_VALUE.VALUE_COMPUTATION': 'Value computation',
		"ACCOUNTING_VALUE.RESOURCE_TYPE": "Resource type",
		'ACCOUNTING_VALUE.VALUE_SUMMATION': 'Value summation',
		'ACCOUNT_ACTIVATION': 'Account activation',
		'ACCOUNT_ACTIVATION.CODE': 'Activation code',
		'ACCOUNT_ACTIVATION.CODE.RESEND': 'Resend activation code',
		'ACCOUNT_ACTIVATION.INTRO': 'Please fill in the activation code you received by email',
		'ACID': 'Acid',
		'ACTIVATE': 'Activate',
		'ACTIVATE.SELECTED': 'Activate selected',
		'ACTIVE': 'Active',
		'ACTIVITIES.DAILY': 'Daily activities',
		'ACTIVITIES.EXPORT': 'Export activities',
		'ACTIVITIES.NO': 'No activities',
		'ACTIVITIES.WEEKLY': 'Weekly activities',
		'ACTIVITY': 'Activity',
		'ACTIVITY.EXPORT_DETAILS': 'Export the selected activity',
		'ACTIVITY.NO_FIELDS_WORKED': 'No work done on known fields',
		'ADAPTER': 'Adapter',
		'ADAPTER.ASSIGN': 'Assign adapter',
		'ADAPTER.ASSIGN.FAILURE': 'There was an error pairing the adapter',
		'ADAPTER.ASSIGN.SUCCESS': 'Adapter successfully assigned',
		'ADAPTER.ASSIGNED_MACHINE': 'Assigned machine',
		'ADAPTER.ASSIGNMENT': 'Assignment of adapters to machines',
		'ADAPTER.CHOSEN': 'Chosen Adapter',
		'ADAPTER.LOAD.FAILURE': 'There was an error loading the Adapters',
		'ADAPTER.NO': 'No Adapter',
		'ADAPTER.NONE_AVAILABLE': 'No Adapter available',
		'ADAPTER.PAIR_INFO': 'Select the corresponding adapter. Already assigned adapters will be overwritten with the new machine. The new configuration will be automatically loaded with the next restart of the adapter.',
		'ADAPTER.PREVIOUS': 'Previous adapter',
		'ADAPTERS.NO': 'No adapters',
		'ADBLUE.LEVEL': 'AdBlue level',
		'ADD': 'Add',
		'ADDITIONAL_VALUE': 'Additional value',
		'ADDITIVE': 'Additive',
		'ADDRESS': 'Address',
		'ALL': 'All',
		'ALL_DEVICES': 'Overall devices',
		'AMOUNT': 'Amount',
		'AMOUNT.INVALID': 'Amount invalid',
		'AMOUNTS': 'Amounts',
		'APPLY': 'Apply',
		'ARCHIVE': 'Archive',
		'ARCHIVE.SELECTED': 'Archive selected',
		'AREA': 'Area',
		'AREA.FIELD': 'Area fields',
		'AREA.LOCATION': 'Area locations',
		'AREA.PERFORMANCE': 'Area per h',
		'AREA.PROCESSED': 'Processed area',
		'AREA.TOTAL': 'Total area',
		'AREA.WORKED': 'Worked area',
		'ASSIGN': 'Assign',
		'AUTH.REMEMBER_ME': 'Remember me',
		'BACK': 'Back',
		'BALES': 'Bales',
		'BASIC_DATA': 'Basic data',
		'BEACON': 'Beacon',
		'BEACON.ASSIGN': 'Assign beacon',
		'BEACON.ASSIGN.SUCCESS': 'Beacon successfully assigned',
		'BEACON.ASSIGNED_EMPLOYEE': 'Assigned employee',
		'BEACON.ASSIGNED_IMPLEMENT': 'Assigned implement',
		'BEACON.ASSIGN_TO_EMPLOYEE': 'Assign beacon to employee',
		'BEACON.ASSIGN_TO_IMPLEMENT': 'Assign beacon to implement',
		'BEACON.CHOSEN': 'Chosen beacon',
		'BEACON.ERROR': 'There was an error pairing the beacon.',
		'BEACON.LOAD_ERROR': 'There was an error loading the beacon',
		'BEACON.NONE_AVAILABLE': 'No beacon available',
		'BEACON.NO_BEACON': 'No beacon',
		'BEACON.PAIR_INFO_EMPLOYEE': 'Select the corresponding beacon. Already assigned beacons will be overwritten with the new employee.',
		'BEACON.PAIR_INFO_IMPLEMENT': 'Select the corresponding beacon. Already assigned beacons will be overwritten with the new implement.',
		'BEACON.PREVIOUS': 'Previous beacon',
		'BEACONS': 'Beacons',
		'BUILD_YEAR': 'Year of construction',
		'BUILD_YEAR.INVALID': 'Build year invalid',
		'CAN.STATUS': 'CAN status',
		'CANCEL': 'Cancel',
		'CHANGE': 'Change',
		'CHANGE.NO': 'No change',
		'CHOOSE_ALL': 'Choose all',
		'CHOOSE_ROLE': 'Choose role',
		'CHRONOLOGICAL': 'Chronological order',
		'CLICK_PROCESS': 'Select a process for more details',
		'CLOSE': 'Close',
		'CO2.EMISSION': 'CO2 emission',
		'CO2.PER': 'Amount of CO2 per ha',
		'CO2.TOTAL': 'Total amount of CO2',
		'COLOR': 'Color',
		'COMMENT': 'Comment',
		'CONDITION': 'Condition',
		'CONFIRM': 'Confirm',
		'CONFIRM_PASSWORD': 'Confirm password',
		'CONNECT': 'Connect',
		'CONTACT_PERSON': 'Contact person',
		'CONTINUE': 'Continue',
		'COST': 'Cost',
		'COST.INVALID': 'Cost invalid',
		'COST.OVERALL': 'Overall cost',
		'COST.OVERALL.ARRIVAL': 'Overall cost arrival',
		'COST.OVERALL.DRIVER': 'Overall cost driver',
		'COST.OVERALL.FIELD_TIME': 'Overall cost on field',
		'COST.OVERALL.IMPLEMENTS': 'Overall cost implements',
		'COST.OVERALL.MACHINES': 'Overall cost machines',
		'COST.OVERALL.PREPARATION': 'Overall cost preparation',
		'COST.TOTAL': 'Total cost',
		'COSTS': 'Costs',
		'COST_RATE': 'Cost rate',
		'COUNTRY': 'Country',
		'COVERAGE': 'Coverage',
		'COVERAGE.MAP': 'Coverage map',
		'COVERAGE.MAP.SETTINGS': 'Coverage map settings',
		'COVERAGE.MAP.ZONES': 'Zones',
		'CREATED': 'Created',
		'CREATE_USER': 'Create user',
		"CROP": "Crop",
		'CROP.TYPE': 'Crop type',
		'CROP.NO_CROP': 'No crop',
		'CURRENCY': 'Currency',
		'CUSTOMER': 'Customer',
		'CUSTOMER.ADD': 'Add new customer',
		'CUSTOMER.ADD.SUCCESS': 'Customer successfully added',
		'CUSTOMER.ASSIGN': 'Assign customer',
		'CUSTOMER.DELETE.QUESTION': 'Do you really want to delete the customer?',
		'CUSTOMER.DELETE.SUCCESS': 'Customer has been deleted',
		'CUSTOMER.DETAILS': 'Customer details',
		'CUSTOMER.EDIT': 'Edit customer',
		'CUSTOMER.EDIT.SUCCESS': 'Customer successfully edited',
		'CUSTOMER.NAME': 'Customer name',
		'CUSTOMER.NO': 'No customer',
		'CUSTOMER.NOT_SELECTED': 'No customer selected',
    'CUSTOMER.NO.ASSIGNEE': 'No customer assigned',
		'CUSTOMER.SELECT': 'Select customer',
		'CUSTOMERS': 'Customers',
		'CUSTOMERS.ALL': 'All customers',
		'CUSTOMERS.DELETE.FAILURE': 'Some of the customers could not be deleted',
		'CUSTOMERS.DELETE.QUESTION': 'Do you want to delete the selected customers?',
		'CUSTOMERS.DELETE.SUCCESS': 'Customers deleted successfully',
		'CUSTOMERS.MANAGEMENT': 'Customers management',
		'CUSTOMERS.NO': 'No customers',
		'CUSTOMERS.SELECTED': 'Selected customers',
		'CUSTOM_LABELING': 'Custom labeling',
		'CUSTOM_LABELING.ADD_WORKSTATE': 'Add new workstate',
		'CUSTOM_LABELING.DEFINE_FOR_IMPLEMENT': 'Define a custom labeling for the selected implement.',
		'CUSTOM_LABELING.DEFINE_INDIVIDUAL_CONDITION': 'Define indivdual conditions for the label.',
		'CUSTOM_LABELING.EDIT.SUCCESS': 'Editing custom labeling successful',
		'CUSTOM_LABELING.INDIVIDUAL_CONDITION': 'Individual condition',
		'CUSTOM_LABELING.ISOBUS_OVERRIDE': 'Allow override with ISOBUS conditions',
		'CUSTOM_LABELING.NO_LABELS_AVAILABLE': 'No labels available',
		'DASHBOARD.GPS_DATA.NO': 'No GPS data',
		'DASHBOARD.MACHINE_POSITIONS.LOAD.FAILURE': 'There was an error loading the machine positions',
		'DATA': 'Data',
		'DATA.ARCHIVED.WARNING': 'Underlying data is partially or fully archived',
		'DATA.EXPORT': 'Data export',
		'DATA.INPUT': 'Data input',
		'DATA.UPDATING.WARNING': 'Underlying data is being updated',
		'DATA_PREPARATION': 'Data preparation',
		'DATE': 'Date',
		'DATE.APRIL': 'April',
		'DATE.AUGUST': 'August',
		'DATE.DECEMBER': 'December',
		'DATE.FEBRUARY': 'February',
		'DATE.FRIDAY': 'Friday',
		'DATE.FROM': 'From',
		'DATE.JANUARY': 'January',
		'DATE.JULY': 'July',
		'DATE.JUNE': 'June',
		'DATE.MARCH': 'March',
		'DATE.MAY': 'May',
		'DATE.MONDAY': 'Monday',
		'DATE.NOVEMBER': 'November',
		'DATE.OCTOBER': 'October',
		'DATE.PERIOD': 'Period',
		'DATE.RANGE': 'Date range',
		'DATE.SATURDAY': 'Saturday',
		'DATE.SEPTEMBER': 'September',
		'DATE.SUNDAY': 'Sunday',
		'DATE.THURSDAY': 'Thursday',
		'DATE.TUESDAY': 'Tuesday',
		'DATE.UNTIL': 'Until',
		'DATE.WEDNESDAY': 'Wednesday',
		'DAY.CURRENT': 'Current day',
		'DAY.NEXT': 'Next day',
		'DAY.PREVIOUS': 'Previous day',
		'DAY.SELECTED': 'Selected day',
		'DAYS': 'Days',
		'DAY_ACTIVITIES': 'Daily activities',
		'DEACTIVATE': 'Deactivate',
		'DEACTIVATE.SELECTED': 'Deactivate selected',
		'DEADLINE': 'Deadline',
		'DEADLINE.ADD': 'Add deadline',
		'DEADLINE.ADD.SUCCESS': 'Deadline successfully added',
		'DEADLINE.DELETE.SUCCESS': 'Deadline successfully deleted',
		'DEADLINE.DONE': 'Finish',
		'DEADLINE.DUE': 'Deadline due',
		'DEADLINE.DUE_IN_AT': 'Due at',
		'DEADLINE.EDIT': 'Edit deadline',
		'DEADLINE.EDIT.SUCCESS': 'Deadline has been edited',
		'DEADLINE.IS_CLOSE': 'This deadline is upcoming',
		'DEADLINE.IS_OVERDUE': 'This deadline is overdue',
		'DEADLINE.OPEN': 'Open',
		'DEADLINE.PROCESS.SUCCESS': 'Deadline successfully processed',
		'DEADLINE.PROCESSED': 'Processed',
		'DEADLINE.PROCESSED.SUCCESS': 'Deadline successfully processed',
		'DEADLINE.WARN': 'Deadline upcoming',
		'DEADLINES': 'Deadlines',
		'DEADLINES.NO': 'No deadlines',
		'DEFINE_ROLE': 'Define role',
		'DELETE': 'Delete',
		'DELETE.SELECTED': 'Delete selected',
		'DELETED': 'Deleted',
		'DESCRIPTION': 'Description',
		'DIAGRAM': 'Diagram',
		'DISPLAY': 'Display',
		'DISPLAY_TRACK': 'Display track',
		'DISTANCE': 'Distance',
		'DISTANCE.TOTAL': 'Total distance',
		'DISTANCE.WORKED': 'Worked distance',
		'DOWNLOAD': 'Download',
		'DRIVER': 'Driver',
		'DRIVER.EDIT': 'Edit driver',
		'DRIVER.FIXED': 'Fixed driver',
		'DRIVER.NO': 'No driver',
		'DRIVER.REMOVE': 'Remove driver',
		'DRIVERS': 'Drivers',
		'DRIVERS.ALL': 'All drivers',
		'DRIVER_SCAN_DISABLED': 'Driver beacon scan inactive',
		'DURATION': 'Duration',
		'DURATION.WORKED': 'Worked duration',
		'EDIT': 'Edit',
		'EDIT.SELECTED': 'Edit selected',
		'EDIT_USER': 'Edit user',
		'EMAIL': 'Contact email',
		'EMAIL.ACTIVATE': 'Activate email',
		'EMAIL.ACTIVATE.CODE': 'Activation code',
		'EMAIL.ACTIVATE.EXPLANATION': 'If you changed your email address, we will send an activation code to your new address.',
		'EMAIL.CHANGE': 'Change email',
		'EMAIL.CHANGE.SUCCESS': 'Email successfully changed',
		'EMAIL.CONFIRM': 'Confirm email',
		'EMAIL.CURRENT': 'Current email',
		'EMAIL.INVALID': 'Email invalid',
		'EMAIL.NEW': 'New email',
		'EMAIL.NO_MATCH': 'Emails do not match',
		'EMPLOYEE': 'Employee',
		'EMPLOYEE.ACTIVATE.QUESTION': 'Do you really want to activate the employee?',
		'EMPLOYEE.ADD': 'Add employee',
		'EMPLOYEE.ADD.SUCCESS': 'Employee successfully added',
		'EMPLOYEE.CREATE': 'Create employee',
		'EMPLOYEE.CREATE.SUCCESS': 'Employee successfully created',
		'EMPLOYEE.DEACTIVATE.QUESTION': 'Do you really want to deactivate the employee?',
		'EMPLOYEE.DELETE.QUESTION': 'Do you really want to remove the employee?',
		'EMPLOYEE.EDIT': 'Edit employee',
		'EMPLOYEE.EDIT.SUCCESS': 'Employee successfully edited',
		'EMPLOYEE.ROLE': 'Role of employee',
		'EMPLOYEE.ROLE_OF': 'Role of employee',
		'EMPLOYEES': 'Employees',
		'EMPLOYEES.ACTIVATE.QUESTION': 'Do you really want to activate the employees?',
		'EMPLOYEES.ACTIVATE.SUCCESS': 'Employees successfully activated',
		'EMPLOYEES.ALL': 'All employees',
		'EMPLOYEES.DEACTIVATE.FAILURE': 'Some of the employees could not be deactivated',
		'EMPLOYEES.DEACTIVATE.QUESTION': 'Do you really want to deactivate the employees?',
		'EMPLOYEES.DEACTIVATE.SUCCESS': 'Employees have been deactivated',
		'EMPLOYEES.DELETE.FAILURE': 'Some of the employees could not be deleted.',
		'EMPLOYEES.DELETE.QUESTION': 'Do you really want to delete the selected employees',
		'EMPLOYEES.DELETE.SUCCESS': 'Employees deleted',
		'EMPLOYEES.MANAGEMENT': 'Employees management',
		'EMPLOYEES.NO': 'No employees',
		'EMPLOYEES.NOT_SELECTED': 'No employees selected',
		'EMPLOYEES.SELECTED': 'Selected employees',
		'EMPLOYER.NO': 'No employer',
		'EMPLOYER.NOT_SELECTED': 'No employer selected',
		'EMPLOYES.NO': 'No employees',
		'END_DRAW_MODE': 'Draw mode cancelled',
		'ENTERPRISE': 'Enterprise',
		'ENTERPRISE.ADD': 'Add enterprise',
		'ENTERPRISE.ADD.EMPLOYER_REQUIRED': 'You need to add an Employer',
		'ENTERPRISE.ADDED.SUCCESS': 'Enterprise successfully added',
		'ENTERPRISE.ADD.SUCCESS': 'Successfully added to enterprise',
		'ENTERPRISE.ENTER_ACCESS_TOKEN': 'Please enter the access code for the enterprise.',
		'ENTERPRISE.NAME': 'Enterprise name',
		'ENTERPRISE.NOT_SELECTED': 'No enterprise selected',
		'ENTERPRISE.OF': 'Enterprise of:',
		'ENTERPRISE.SETTINGS': 'Enterprise settings',
		'ENTERPRISE.SETTINGS.CONFIGURATION_UPDATE.SUCCESS': 'Enterprise configuration updated successfully',
		'ENTERPRISE.SETTINGS.MACHINES_SYNC.SUCCESS': 'Machines synchronised successfully',
		'ENTERPRISE_LICENSE.EMPLOYEES': 'Employees licenses',
		'ENTERPRISE_LICENSE.LICENSE': 'License',
		'ENTERPRISE_LICENSE.MACHINE': 'Machine license',
		'ENTERPRISE_LICENSE.MACHINES': 'Machines licenses',
		'ENTERPRISE_MIN': 'Enterprise name must contain at least 3 characters',
		'ENTERPRISE_NAME_REQUIRED': 'Enterprise name required',
		'ENTERPRISE_SELECTION.ADD_ENTERPRISE': 'Add enterprise',
		'ENTERPRISE_SELECTION.LICENSE_EXPIRED': 'License expired',
		'ENTERPRISE_SELECTION.REQUEST_TEST_ACCOUNT': 'Request test account',
		'ENTERPRISE_STATISTICS': 'Enterprise statistics',
		'ENTERPRISE_STATISTICS.COST_DIAGRAMM': 'Cost diagram',
		'ENTERPRISE_STATISTICS.PROCESS_DIVISION': 'Process division',
		'ENUM.ACCOUNTING_COMP_MODE.A': 'All',
		'ENUM.ACCOUNTING_COMP_MODE.WT': 'Working / Transporting',
		'ENUM.ACCOUNTING_MODE.AVG': 'Average',
		'ENUM.ACCOUNTING_MODE.MAX': 'Maximum',
		'ENUM.ACCOUNTING_MODE.MED': 'Median',
		'ENUM.ACCOUNTING_MODE.MIN': 'Minimum',
		'ENUM.ACCOUNTING_MODE.SUM': 'Sum',
		'ENUM.ACCOUNTING_VALUE_MODE.ABSDIF': 'Absolute difference',
		'ENUM.ACCOUNTING_VALUE_MODE.DIR': 'Direct',
		'ENUM.ACCOUNTING_VALUE_MODE.NEGDIF': 'Negative difference',
		'ENUM.ACCOUNTING_VALUE_MODE.POSDIF': 'Positive difference',
		'ENUM.ACCOUNTING_VALUE_MODE.TIMACT': 'Time active',
		'ENUM.BEACONTYPE.BDrv': 'Driver beacon',
		'ENUM.BEACONTYPE.BImpl': 'Implement beacon',
		'ENUM.CAN_IDENTIFIER.A1': 'IO-Box: Analog 1',
		'ENUM.CAN_IDENTIFIER.A2': 'IO-Box: Analog 2',
		'ENUM.CAN_IDENTIFIER.A3': 'IO-Box: Analog 3',
		'ENUM.CAN_IDENTIFIER.A4': 'IO-Box: Analog 4',
		'ENUM.CAN_IDENTIFIER.AUX0_Ext_Fl': 'AUX0 external flow',
		'ENUM.CAN_IDENTIFIER.AUX0_Ret_Fl': 'AUX0 retracting flow',
		'ENUM.CAN_IDENTIFIER.AUX1_Ext_Fl': 'AUX1 external flow',
		'ENUM.CAN_IDENTIFIER.AUX1_Ret_Fl': 'AUX1 retracting flow',
		'ENUM.CAN_IDENTIFIER.AUX2_Ext_Fl': 'AUX2 external flow',
		'ENUM.CAN_IDENTIFIER.AUX2_Ret_Fl': 'AUX2 retracting flow',
		'ENUM.CAN_IDENTIFIER.AUX3_Ext_Fl': 'AUX3 external flow',
		'ENUM.CAN_IDENTIFIER.AUX3_Ret_Fl': 'AUX3 retracting flow',
		'ENUM.CAN_IDENTIFIER.AUX4_Ext_Fl': 'AUX4 external flow',
		'ENUM.CAN_IDENTIFIER.AUX4_Ret_Fl': 'AUX4 retracting flow',
		'ENUM.CAN_IDENTIFIER.Ag1avg': 'IO-Box: Angle 1 average',
		'ENUM.CAN_IDENTIFIER.Ag1max': 'IO-Box: Angle 1 max',
		'ENUM.CAN_IDENTIFIER.Ag1min': 'IO-Box: Angle 1 min',
		'ENUM.CAN_IDENTIFIER.Ag2avg': 'IO-Box: Angle 2 average',
		'ENUM.CAN_IDENTIFIER.Ag2max': 'IO-Box: Angle 2 max',
		'ENUM.CAN_IDENTIFIER.Ag2min': 'IO-Box: Angle 2 min',
		'ENUM.CAN_IDENTIFIER.Ag3avg': 'IO-Box: Angle 3 average',
		'ENUM.CAN_IDENTIFIER.Ag3max': 'IO-Box: Angle 3 max',
		'ENUM.CAN_IDENTIFIER.Ag3min': 'IO-Box: Angle 3 min',
		'ENUM.CAN_IDENTIFIER.ApplAci': 'SyreN: Applied acid',
		'ENUM.CAN_IDENTIFIER.ApplAdd': 'SyreN: Applied additives',
		'ENUM.CAN_IDENTIFIER.ApplSlu': 'SyreN: Applied slurry',
		'ENUM.CAN_IDENTIFIER.AxleWeight_1': 'Axle Weight 1',
		'ENUM.CAN_IDENTIFIER.AxleWeight_2': 'Axle Weight 2',
		'ENUM.CAN_IDENTIFIER.C1': 'IO-Box: Counter 1',
		'ENUM.CAN_IDENTIFIER.C2': 'IO-Box: Counter 2',
		'ENUM.CAN_IDENTIFIER.Chop_Act': 'Chopper',
		'ENUM.CAN_IDENTIFIER.Circ_1_Stat': 'Circ_1_Stat',
		'ENUM.CAN_IDENTIFIER.Circ_2A_Stat': 'Circ_2A_Stat',
		'ENUM.CAN_IDENTIFIER.Circ_2B_Stat': 'Circ_2B_Stat',
		'ENUM.CAN_IDENTIFIER.Circ_3_Stat': 'Circ_3_Stat',
		'ENUM.CAN_IDENTIFIER.Circ_4_Stat': 'Circ_4_Stat',
		'ENUM.CAN_IDENTIFIER.ClutSlip': 'Clutch slip',
		'ENUM.CAN_IDENTIFIER.Cutter_Guide': 'Cutter guide',
		'ENUM.CAN_IDENTIFIER.Cutter_GuideP': 'Cutter guide (P)',
		'ENUM.CAN_IDENTIFIER.Cutter_Pos': 'Cutter position',
		'ENUM.CAN_IDENTIFIER.Cutter_State': 'Cutter',
		'ENUM.CAN_IDENTIFIER.D1': 'IO-Box: Digital 1',
		'ENUM.CAN_IDENTIFIER.D2': 'IO-Box: Digital 2',
		'ENUM.CAN_IDENTIFIER.D3': 'IO-Box: Digital 3',
		'ENUM.CAN_IDENTIFIER.D4': 'IO-Box: Digital 4',
		'ENUM.CAN_IDENTIFIER.Driv_Lever': 'Drive lever',
		'ENUM.CAN_IDENTIFIER.ENG_ABLev': 'AdBlue level',
		'ENUM.CAN_IDENTIFIER.ENG_FueLev': 'Fuel level',
		'ENUM.CAN_IDENTIFIER.ENG_FueRat': 'Fuel rate',
		'ENUM.CAN_IDENTIFIER.ENG_Spe': 'RPM',
		'ENUM.CAN_IDENTIFIER.ENG_Tor': 'Torque',
		'ENUM.CAN_IDENTIFIER.FHitch_Pos': 'Hitch position front',
		'ENUM.CAN_IDENTIFIER.FPTO_Eng': 'PTO front active',
		'ENUM.CAN_IDENTIFIER.FPTO_Spe': 'PTO speed front',
		'ENUM.CAN_IDENTIFIER.Field_Switch': 'Field_Switch',
		'ENUM.CAN_IDENTIFIER.Field_Switch2': 'Field_Switch2',
		'ENUM.CAN_IDENTIFIER.Front_Draft': 'Draft front',
		'ENUM.CAN_IDENTIFIER.Front_NForce': 'Draft (nominal) front',
		'ENUM.CAN_IDENTIFIER.GB_Dir': 'Direction (ground based)',
		'ENUM.CAN_IDENTIFIER.GB_Speed': 'Speed groundbased',
		'ENUM.CAN_IDENTIFIER.GPS_Speed': 'Speed GPS',
		'ENUM.CAN_IDENTIFIER.Gear_Sel': 'Selected gear',
		'ENUM.CAN_IDENTIFIER.GrainCnv_Pos': 'Grain conveyor position',
		'ENUM.CAN_IDENTIFIER.GrainTnk_Lev': 'Graintank level',
		'ENUM.CAN_IDENTIFIER.HySt_Dir': 'HySt_Dir',
		'ENUM.CAN_IDENTIFIER.HySt_Mod': 'HySt_Mod',
		'ENUM.CAN_IDENTIFIER.Impl_Work': 'Implement workstate',
		'ENUM.CAN_IDENTIFIER.JbSta': 'SyreN: Job active',
		'ENUM.CAN_IDENTIFIER.Mot_L_Spe': 'Motor (left) speed',
		'ENUM.CAN_IDENTIFIER.Mot_L_Tor': 'Motor (left) torque',
		'ENUM.CAN_IDENTIFIER.Mot_R_Spe': 'Motor (right) speed',
		'ENUM.CAN_IDENTIFIER.Mot_R_Tor': 'Motor (right) torque',
		'ENUM.CAN_IDENTIFIER.NO_XTR': 'No value',
		'ENUM.CAN_IDENTIFIER.NUE_abs': 'SyreN: NUE absolute',
		'ENUM.CAN_IDENTIFIER.NUE_rel': 'SyreN: NUE relative',
		'ENUM.CAN_IDENTIFIER.PHSlu': 'SyreN: Slurry pH',
		'ENUM.CAN_IDENTIFIER.PTO_Switch': 'PTO_Switch',
		'ENUM.CAN_IDENTIFIER.PTO_Switch1': 'PTO_Switch1',
		'ENUM.CAN_IDENTIFIER.PTO_Switch2': 'PTO_Switch2',
		'ENUM.CAN_IDENTIFIER.PTO_Switch3': 'PTO_Switch3',
		'ENUM.CAN_IDENTIFIER.PrxSen': 'IO-Box: Proximitysensor',
		'ENUM.CAN_IDENTIFIER.RHitch_Pos': 'Hitch position rear',
		'ENUM.CAN_IDENTIFIER.RPTO_Eng': 'PTO rear active',
		'ENUM.CAN_IDENTIFIER.RPTO_Spe': 'PTO speed rear',
		'ENUM.CAN_IDENTIFIER.Rear_Draft': 'Draft rear',
		'ENUM.CAN_IDENTIFIER.Rear_NForce': 'Draft (nominal) rear',
		'ENUM.CAN_IDENTIFIER.Roll': 'IO-Box: Rollrate',
		'ENUM.CAN_IDENTIFIER.Sli': 'Slip',
		'ENUM.CAN_IDENTIFIER.Spe': 'Speed',
		'ENUM.CAN_IDENTIFIER.StrawChop_Pos': 'Strawchopper position',
		'ENUM.CAN_IDENTIFIER.Thresh_Drum': 'Thresh drum',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A1': 'Tire pressure left A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A2': 'Tire pressure left A2',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A1': 'Tire pressure right A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A2': 'Tire pressure right A2',
		'ENUM.CAN_IDENTIFIER.UnlAuger_Act': 'UnlAuger_Act',
		'ENUM.CAN_IDENTIFIER.WB_Dir': 'Direction (wheel based)',
		'ENUM.CAN_IDENTIFIER.WB_Speed': 'Speed wheelbased',
		'ENUM.CAN_IDENTIFIER.Xacc': 'IO-Box: Acceleration X',
		'ENUM.CAN_IDENTIFIER.Yacc': 'IO-Box: Acceleration Y',
		'ENUM.CAN_IDENTIFIER.Yaw': 'IO-Box: Yaw',
		'ENUM.CAN_IDENTIFIER.Yield_Act': 'Actual yield',
		'ENUM.CAN_IDENTIFIER.Yield_Mois': 'Yield moisture',
		'ENUM.CAN_IDENTIFIER.Zacc': 'IO-Box: Acceleration Z',
		'ENUM.COSTPER.h': 'h',
		'ENUM.COSTPER.ha': 'ha',
		'ENUM.COSTPER.km': 'km',
		'ENUM.COSTPER.l': 'l',
		'ENUM.CURRENCY.DOLLAR': '$',
		'ENUM.CURRENCY.EURO': '€',
		'ENUM.CURRENCY.GBP': '£',
		'ENUM.EMPLOYEEROLE.ADMIN': 'Admin',
		'ENUM.EMPLOYEEROLE.CONSULTANT': 'Consultant',
		'ENUM.EMPLOYEEROLE.DISPONENT': 'Dispatcher',
		'ENUM.EMPLOYEEROLE.DRIVER': 'Driver',
		'ENUM.EVENTTYPE.COMMENT': 'Message',
		'ENUM.EVENTTYPE.CT': 'Counter',
		'ENUM.EVENTTYPE.CT_RS': 'Counter reset',
		'ENUM.EVENTTYPE.CUSTOMER': 'Customer',
		'ENUM.EVENTTYPE.EMPL_C_IMPL': 'Employee couples implement',
		'ENUM.EVENTTYPE.EMPL_E_FIELD': 'Employee enters field',
		'ENUM.EVENTTYPE.EMPL_E_MACH': 'Employee enters tractor',
		'ENUM.EVENTTYPE.EMPL_L_FIELD': 'Employee leaves field',
		'ENUM.EVENTTYPE.EMPL_L_MACH': 'Employee leaves tractor',
		'ENUM.EVENTTYPE.EMPL_P_START': 'Employee starts break',
		'ENUM.EVENTTYPE.EMPL_P_STOP': 'Employee finishes break',
		'ENUM.EVENTTYPE.EMPL_UC_IMPL': 'Employee uncouples implement',
		'ENUM.EVENTTYPE.EMPL_W_START': 'Employee starts work',
		'ENUM.EVENTTYPE.EMPL_W_STOP': 'Employee finishes work',
		'ENUM.EVENTTYPE.GTO70': 'Grain tank full',
		'ENUM.EVENTTYPE.JOBINFO': 'Job info',
		'ENUM.EVENTTYPE.JOB_PAUSE': 'Job pause',
		'ENUM.EVENTTYPE.JOB_RESUME': 'Job resume',
		'ENUM.EVENTTYPE.JOB_START': 'Job start',
		'ENUM.EVENTTYPE.JOB_STOP': 'Job stop',
		'ENUM.EVENTTYPE.L_IMPL': 'Implement loaded',
		'ENUM.EVENTTYPE.REFUELING': 'Refueling',
		'ENUM.EVENTTYPE.SYREN_CUSTOMER': 'SyreN customer',
		'ENUM.EVENTTYPE.SYREN_FIELD': 'SyreN field',
		'ENUM.EVENTTYPE.SYREN_SLURRY_TYPE': 'SyreN slurry type',
		'ENUM.EVENTTYPE.T2_ON': 'Adapter online',
		'ENUM.EVENTTYPE.UL_IMPL': 'Implement unloaded',
		'ENUM.EVENTTYPE.WEATHER': 'Weather',
		'ENUM.EVENTTYPE.WEIGHING': 'Weighing',
		'ENUM.EVENTTYPE.WEIGHING_TARA': 'Weighing (tare)',
		'ENUM.ISO_TASKDATA_STATE.CRE': 'Created',
		'ENUM.ISO_TASKDATA_STATE.ONM': 'On machine',
		'ENUM.ISO_TASKDATA_STATE.RDY': 'Ready',
		'ENUM.JOBGENERATIONSTATE.ARC': 'Archived',
		'ENUM.JOBGENERATIONSTATE.DEL': 'Deleting',
		'ENUM.JOBGENERATIONSTATE.EDT': 'Editing',
		'ENUM.JOBGENERATIONSTATE.GEN': 'Generating',
		'ENUM.JOBGENERATIONSTATE.MER': 'Merging',
		'ENUM.JOBGENERATIONSTATE.QUE': 'Queued',
		'ENUM.JOBGENERATIONSTATE.READY': 'OK',
		'ENUM.JOBGENERATIONSTATE.REGEN': 'Regenerating',
		'ENUM.JOBGENERATIONSTATE.SPLT': 'Splitting',
		'ENUM.JOBGENERATIONSTATE.UPD': 'Updating',
		'ENUM.LOCATIONTYPE.FARM': 'Farm',
		'ENUM.LOCATIONTYPE.FUEL': 'Fuel station',
		'ENUM.LOCATIONTYPE.OTHERS': 'Other',
		'ENUM.LOCATIONTYPE.STABLE': 'Stable',
		'ENUM.LOCATIONTYPE.WEIGHING': 'Scale',
		'ENUM.MACHINETYPE.COMBINE': 'Combine harvester',
		'ENUM.MACHINETYPE.EXCAVATOR': 'Excavator',
		'ENUM.MACHINETYPE.FORAGE_HARVESTER': 'Forage harvester',
		'ENUM.MACHINETYPE.MISC': 'Other',
		'ENUM.MACHINETYPE.SELF_PROPELLED': 'Self propelled',
		'ENUM.MACHINETYPE.SYREN': 'Syren',
		'ENUM.MACHINETYPE.TELEHANDLER': 'Telehandler',
		'ENUM.MACHINETYPE.TRACTOR': 'Tractor',
		'ENUM.MACHINETYPE.TRUCK': 'Truck',
		'ENUM.MACHINETYPE.WHEELLOADER': 'Wheelloader',
		'ENUM.MSGUNIT.-': '-',
		'ENUM.MSGUNIT.AXLES': 'Axles',
		'ENUM.MSGUNIT.CUBIC_M': 'm³',
		'ENUM.MSGUNIT.DOLLAR': '$',
		'ENUM.MSGUNIT.EURO': '€',
		'ENUM.MSGUNIT.KG': 'kg',
		'ENUM.MSGUNIT.LITER': 'l',
		'ENUM.MSGUNIT.TONS': 't',
		'ENUM.MSGUNIT.h': 'h',
		'ENUM.MSGUNIT.ha': 'ha',
		'ENUM.MSGUNIT.km': 'km',
		'ENUM.ONLY_ON_STATE.A': 'Always',
		'ENUM.ONLY_ON_STATE.F': 'Field',
		'ENUM.ONLY_ON_STATE.L': 'Location',
		'ENUM.ONLY_ON_STATE.R': 'Road',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_1200': 'AgLeader InCommand 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_800': 'AgLeader InCommand 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INTEGRA': 'AgLeader Integra',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_VERSA': 'AgLeader Versa',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD': 'Amazone Amapad',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD_2': 'Amazone Amapad 2',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_3': 'Amazone Amatron 3',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_4': 'Amazone Amatron 4',
		'ENUM.TRACTOR_TERMINAL_TYPE.AN_L10I': 'Andeo L10i',
		'ENUM.TRACTOR_TERMINAL_TYPE.A_XY': 'A_XY',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_1200': 'Case AFS Pro 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_700': 'Case AFS Pro 700',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_1200': 'CCI 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_800': 'CCI 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_CEMIS_1200': 'Claas Cemis 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S10': 'Claas S10',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S7': 'Claas S7',
		'ENUM.TRACTOR_TERMINAL_TYPE.C_S2034': 'C_S2034',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_ONE': 'Fendt One',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_VARIOTERMINAL_10_4': 'Fendt Varioterminal 10.4',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_2630': 'John Deere 2630',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_GEN4': 'John Deere Gen4',
		'ENUM.TRACTOR_TERMINAL_TYPE.KV_TELLUS': 'Kverneland Tellus',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME': 'Müller Elektronik Basic',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_COMFORT': 'Müller Elektronik Comfort',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_1200': 'Müller Elektronik Touch 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_800': 'Müller Elektronik Touch 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.MF_DATATRONIC_5': 'MF Datatronic 5',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR12': 'Raven CR12',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR7': 'Raven CR7',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_VIPER4': 'Raven Viper4',
		'ENUM.TRACTOR_TERMINAL_TYPE.RH_SMART_COMMAND': 'Reichhardt Smart Command',
		'ENUM.TRACTOR_TERMINAL_TYPE.SDF_IMONITOR3': 'SDF iMonitor3',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X25': 'Topcon x25',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X30': 'Topcon x30',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X35': 'Topcon x35',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_XD': 'Topcon XD',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_1260': 'Trimble GFX 1260',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_750': 'Trimble GFX 750',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_TMX_2050': 'Trimble TMX 2050',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_1': 'Type 1 (writes on USB stick)',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_2': 'Type 2 (does not write on USB stick)',
		'ENUM.TRANSPORTUNIT.-': '-',
		'ENUM.TRANSPORTUNIT.AXLES': 'Axles',
		'ENUM.TRANSPORTUNIT.BALE': 'Bale',
		'ENUM.TRANSPORTUNIT.CUBIC_M': 'm³',
		'ENUM.TRANSPORTUNIT.KG': 'kg',
		'ENUM.TRANSPORTUNIT.LITER': 'l',
		'ENUM.TRANSPORTUNIT.TONS': 't',
		'ENUM.USERROLE.ADMIN': 'Admin',
		'ENUM.USERROLE.ENTERPRISE': 'Enterprise',
		'ENUM.USERROLE.SALES_FORCE_TECH': 'Tech. Saleforce',
		'ENUM.USERROLE.TRAN': 'Translation',
		'ENUM.USERROLE.USER': 'User',
		'ENUM.USERROLE.USER_EMPL': 'User (Enterprise)',
		'ENUM.USERSTATE.ACTIVE': 'Active',
		'ENUM.USERSTATE.DISABLED': 'Disabled',
		'ENUM.USERSTATE.NOT_VERIFIED': 'Not verified',
		'ENUM.WORKSTATE.DRIVING': 'Driving',
		'ENUM.WORKSTATE.DRIVING_MISC': 'Waiting driving',
		'ENUM.WORKSTATE.MISC_FIELD': 'Waiting field',
		'ENUM.WORKSTATE.MISC_FIELD_GTF': 'Graintank full',
		'ENUM.WORKSTATE.MISC_ROAD': 'Waiting road',
		'ENUM.WORKSTATE.PAUSE': 'Pause',
		'ENUM.WORKSTATE.PREPARATION': 'Preparation',
		'ENUM.WORKSTATE.ROAD': 'Road',
		'ENUM.WORKSTATE.THRESHING': 'Threshing',
		'ENUM.WORKSTATE.THRESHING_U': 'Unloading while threshing',
		'ENUM.WORKSTATE.THRESHING_W_SC': 'Threshing with straw chopper',
		'ENUM.WORKSTATE.THRESHING_W_SC_U': 'Unloading while threshing with straw chopper',
		'ENUM.WORKSTATE.TRANSPORT_LOADED': 'Loaded',
		'ENUM.WORKSTATE.TRANSPORT_LOADED_MISC': 'Loaded waiting',
		'ENUM.WORKSTATE.TRANSPORT_LOADING': 'Loading',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED': 'Unloaded',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED_MISC': 'Unloaded waiting',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING': 'Unloading',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING_DRIV': 'Unloading while driving',
		'ENUM.WORKSTATE.TURNING': 'Turning',
		'ENUM.WORKSTATE.UNDEFINED': 'Undefined',
		'ENUM.WORKSTATE.WORKING': 'Working',
		'ENUM.WORKSTATE.WORKING_MISC': 'Waiting working',
		'ERROR.NO_GPS_DATA': 'No gps data for the selected machine.',
		'ERROR_MESSAGE': 'Error message',
		'EVENTS': 'Events',
		'EVENTS.FIELD': 'Events on field',
		'EVENTS.NO': 'No events',
		'EXA_ADAPTERS': 'Adapter',
		'EXA_ADAPTERS.AR_ACTIVATE': 'Activate adapter in Agrirouter',
		'EXA_ADAPTERS.AR_DEACTIVATE': 'Delete adapter in Agrirouter',
		'EXA_ADAPTERS.AR_LINK_SUCCESS': 'Adapter activated in Agrirouter',
		'EXA_ADAPTERS.AR_UNLINK_SUCCESS': 'Adapter deleted from Agrirouter',
		'EXCEPTION.1': 'Internal error',
		'EXCEPTION.100': 'Enum invalid',
		'EXCEPTION.1000': 'Username is empty',
		'EXCEPTION.10000': 'Filename is empty',
		'EXCEPTION.10001': 'Data is empty',
		'EXCEPTION.10002': 'FormatType invalid',
		'EXCEPTION.10003': 'DataRequestType invalid',
		'EXCEPTION.10004': 'No raw data',
		'EXCEPTION.1001': 'Username length is below minimal length',
		'EXCEPTION.1002': 'Username is already taken',
		'EXCEPTION.1003': 'Email address invalid',
		'EXCEPTION.1004': 'Email address is already taken',
		'EXCEPTION.1005': 'Password length is below minimal length',
		'EXCEPTION.1007': 'Verificationcode invalid',
		'EXCEPTION.1008': 'Username (or email address) invalid',
		'EXCEPTION.101': 'Employee role invalid',
		'EXCEPTION.1011': 'User does not exist',
		'EXCEPTION.1012': 'User is deleted',
		'EXCEPTION.1013': 'User is inactive',
		'EXCEPTION.1014': 'User is blocked',
		'EXCEPTION.1015': 'User is not activated',
		'EXCEPTION.1016': 'User is an enterprise account',
		'EXCEPTION.102': 'Currency invalid',
		'EXCEPTION.1020': 'User already exists',
		'EXCEPTION.1021': 'Email address already taken',
		'EXCEPTION.1022': 'Email address has not changed',
		'EXCEPTION.1023': 'Current password does not match',
		'EXCEPTION.1024': 'Username is already taken',
		'EXCEPTION.1025': 'User and code do not match',
		'EXCEPTION.1026': 'Username (or email address) invalid',
		'EXCEPTION.1027': 'User already activated',
		'EXCEPTION.1028': 'Forbidden for employee accounts created for an enterprise',
		'EXCEPTION.103': 'Transport unit invalid',
		'EXCEPTION.104': 'Location type invalid',
		'EXCEPTION.105': 'Cost unit invalid',
		'EXCEPTION.106': 'Unit invalid',
		'EXCEPTION.107': 'Machine type invalid',
		'EXCEPTION.108': 'Employee status invalid',
		'EXCEPTION.11000': 'Type invalid',
		'EXCEPTION.12000': 'Type invalid',
		'EXCEPTION.12002': 'Serial is empty',
		'EXCEPTION.12003': 'Work state invalid',
		'EXCEPTION.12004': 'Job state invalid',
		'EXCEPTION.12006': 'No T2 config',
		'EXCEPTION.12007': 'MAC is empty',
		'EXCEPTION.12008': 'MAC invalid',
		'EXCEPTION.12009': 'Adapter already exists',
		'EXCEPTION.12010': 'Adapter type invalid',
		'EXCEPTION.15000': 'Start time is empty or in the future',
		'EXCEPTION.15001': 'Stop time is empty or in the future',
		'EXCEPTION.15002': 'Stop time is equal or before start time',
		'EXCEPTION.15003': 'Not able to generate the SILO package - no raw data',
		'EXCEPTION.15004': 'Raw data too old',
		'EXCEPTION.16000': 'Name is empty',
		'EXCEPTION.16001': 'Assigned customer does not exist',
		'EXCEPTION.16002': 'Marker list is empty',
		'EXCEPTION.16003': 'Marker list has to contain at least three marker',
		'EXCEPTION.16004': 'Area is empty',
		'EXCEPTION.16005': 'Marker type invalid',
		'EXCEPTION.16006': 'Field is not contained in job',
		'EXCEPTION.16007': 'Grid size is greater than half of height and width of the field',
		'EXCEPTION.16008': 'No data to interpolate',
		'EXCEPTION.16009': 'All data contain the same value',
		'EXCEPTION.17000': 'Name is empty',
		'EXCEPTION.17001': 'Contact person is empty',
		'EXCEPTION.17002': 'Phone is empty',
		'EXCEPTION.17003': 'Email address is empty',
		'EXCEPTION.17004': 'Email address invalid',
		'EXCEPTION.17005': 'Address is empty',
		'EXCEPTION.17006': 'Zip code is empty',
		'EXCEPTION.17007': 'City is empty',
		'EXCEPTION.17008': 'Color invalid ((AA)RRGGBB)',
		'EXCEPTION.18000': 'Type invalid',
		'EXCEPTION.19001': 'Type invalid',
		'EXCEPTION.19002': 'MAC is empty',
		'EXCEPTION.19003': 'MAC invalid',
		'EXCEPTION.19004': 'Power is less than zero',
		'EXCEPTION.19007': 'Employee is empty',
		'EXCEPTION.19008': 'Beacon is no implement beacon',
		'EXCEPTION.19009': 'Beacon is no driver beacon',
		'EXCEPTION.2': 'Duplicate entry',
		'EXCEPTION.200': 'Error parsing Json Object Type',
		'EXCEPTION.2000': 'Verificationcode creation failed',
		'EXCEPTION.20000': 'Raw data amount too low',
		'EXCEPTION.20001': 'Archive file creation failed',
		'EXCEPTION.20002': 'Archive file loading failed',
		'EXCEPTION.2001': 'Verification code does not exist',
		'EXCEPTION.2002': 'Verification code invalid',
		'EXCEPTION.201': 'Error writing Object Type to Json',
		'EXCEPTION.21000': 'Enterprise name is empty',
		'EXCEPTION.21001': 'Enterprise name already taken',
		'EXCEPTION.21002': 'Enterprise name length is below minimum length',
		'EXCEPTION.21003': 'Enterprise email address invalid',
		'EXCEPTION.21004': 'Access token already exists',
		'EXCEPTION.21005': 'Enterprise is deleted',
		'EXCEPTION.21006': 'Enterprise is deactivated',
		'EXCEPTION.21007': 'Enterprise is blocked',
		'EXCEPTION.21008': 'Enterprise type invalid',
		'EXCEPTION.22000': 'No jobs to add',
		'EXCEPTION.22001': 'No jobs changed',
		'EXCEPTION.23000': 'Enterprise not onboarded',
		'EXCEPTION.23001': 'Enterprise already onboarded',
		'EXCEPTION.23002': 'Adapter not onboarded',
		'EXCEPTION.23003': 'Adapter already onboarded',
		'EXCEPTION.23004': 'Could not onboard adapter',
		'EXCEPTION.23005': 'Could not reonboard adapter',
		'EXCEPTION.23006': 'Could not offboard adapter',
		'EXCEPTION.23007': 'Publishing vCU capabilities failed',
		'EXCEPTION.23008': 'Publishing vCU data failed',
		'EXCEPTION.23009': 'Publishing vCU device description failed',
		'EXCEPTION.23010': 'Publishing enterprise capabilities failed',
		'EXCEPTION.23011': 'Agrirouter certificate error! Did you renew the Agrirouter connection?',
		'EXCEPTION.24000': 'Enterprise name is empty',
		'EXCEPTION.24001': 'Enterprise name already taken',
		'EXCEPTION.24002': 'Enterprise name length is below minimum length',
		'EXCEPTION.24003': 'Enterprise email address invalid',
		'EXCEPTION.24004': 'Access token already exists',
		'EXCEPTION.24005': 'Enterprise is deleted',
		'EXCEPTION.24006': 'Enterprise is deactivated',
		'EXCEPTION.24007': 'Enterprise is blocked',
		'EXCEPTION.25000': 'Function not available for selected partner',
		'EXCEPTION.25001': 'Synchronizing fields failed',
		'EXCEPTION.25002': 'Synchronizing machines failed',
		'EXCEPTION.25003': 'Synchronizing implements failed',
		'EXCEPTION.25004': 'Getting machine failed',
		'EXCEPTION.25005': 'Creating machine failed',
		'EXCEPTION.25006': 'Updating machine failed',
		'EXCEPTION.25007': 'Deleting machine failed',
		'EXCEPTION.25008': 'Getting implement failed',
		'EXCEPTION.25009': 'Creating implement failed',
		'EXCEPTION.25010': 'Updating implement failed',
		'EXCEPTION.25011': 'Deleting implement failed',
		'EXCEPTION.26000': 'PDF file creation failed',
		'EXCEPTION.26001': 'The selected job is no SyreN enabled job',
		'EXCEPTION.27000': 'Machine does not support TaskData files',
		'EXCEPTION.27001': 'TaskData file creation failed',
		'EXCEPTION.27002': 'TaskData file loading failed',
		'EXCEPTION.27003': 'Machine has no assigned adapter',
		'EXCEPTION.27004': 'Name is empty',
		'EXCEPTION.27005': 'Planned date is empty',
		'EXCEPTION.27006': 'Planned date is not in the future',
		'EXCEPTION.27007': 'State is empty',
		'EXCEPTION.27008': 'File is empty',
		'EXCEPTION.27009': 'Filename is empty',
		'EXCEPTION.27010': 'Date is empty',
		'EXCEPTION.27011': 'Date is not in the future',
		'EXCEPTION.27012': 'Size is below one',
		'EXCEPTION.27013': 'TaskData operation not availabe in current state',
		'EXCEPTION.27014': 'File name already taken',
		'EXCEPTION.27015': 'No open tasks',
		'EXCEPTION.27016': 'Only one non downloaded TaskData file allowed',
		'EXCEPTION.28001': 'File type not supported',
		'EXCEPTION.29000': 'Update not allowed (already processed)',
		'EXCEPTION.29001': 'No machine or implement given',
		'EXCEPTION.29002': 'Only machine OR implement allowed',
		'EXCEPTION.29003': 'Base value has to be greater than zero',
		'EXCEPTION.29004': 'Warn value has to be greater than zero',
		'EXCEPTION.29005': 'Due value has to be greater than zero',
		'EXCEPTION.29006': 'Due interval has to be greater than warn interval',
		'EXCEPTION.3000': 'Login information invalid',
		'EXCEPTION.3001': 'Account is blocked',
		'EXCEPTION.3002': 'Account is not activated',
		'EXCEPTION.3003': 'Session expired - Please log in again',
		'EXCEPTION.3004': 'Another user logged in with the same account',
		'EXCEPTION.31000': 'App not supported',
		'EXCEPTION.4000': 'Make is empty',
		'EXCEPTION.4001': 'Model is empty',
		'EXCEPTION.4002': 'Year has to be greated than 1950 and not in the future',
		'EXCEPTION.4003': 'Cost is less than or equal zero',
		'EXCEPTION.4004': 'Operating hours are less than zero',
		'EXCEPTION.4005': 'Mileage is less than zero',
		'EXCEPTION.4007': 'Working width is less than zero',
		'EXCEPTION.4008': 'Color invalid ((AA)RRGGBB)',
		'EXCEPTION.4009': 'XtrCanValuesConfig invalid',
		'EXCEPTION.401': 'Unauthorized',
		'EXCEPTION.4010': 'Too many config values',
		'EXCEPTION.4011': 'Dynamic config invalid',
		'EXCEPTION.4012': 'Machine type is not Tractor',
		'EXCEPTION.4013': 'Maximum number of licenses are taken',
		'EXCEPTION.4014': 'Date is in the future',
		'EXCEPTION.4015': 'Speed override invalid',
		'EXCEPTION.403': 'Forbidden',
		'EXCEPTION.450': 'Command error',
		'EXCEPTION.451': 'No required license',
		'EXCEPTION.452': 'Filter parameter invalid',
		'EXCEPTION.5000': 'Make is empty',
		'EXCEPTION.5001': 'Model is empty',
		'EXCEPTION.5002': 'Year has to be greated than 1950 and not in the future',
		'EXCEPTION.5003': 'Type1 is empty',
		'EXCEPTION.5004': 'Type2 invalid',
		'EXCEPTION.5005': 'Cost is less than or equals zero',
		'EXCEPTION.5006': 'Working width is less than zero',
		'EXCEPTION.5007': 'Transport value is less than zero',
		'EXCEPTION.5008': 'Transport unit invalid',
		'EXCEPTION.5009': 'Type3 invalid',
		'EXCEPTION.5010': 'Type combination invalid',
		'EXCEPTION.5011': 'Accounting identifier invalid',
		'EXCEPTION.6000': 'Type invalid',
		'EXCEPTION.6001': 'Radius is empty or below zero',
		'EXCEPTION.6002': 'Name is empty',
		'EXCEPTION.6003': 'Marker list is empty',
		'EXCEPTION.6004': 'Marker list has to contain at least three marker',
		'EXCEPTION.6005': 'Marker type invalid',
		'EXCEPTION.6006': 'Weighing type invalid',
		'EXCEPTION.700': 'VarName invalid',
		'EXCEPTION.7001': 'Account does not exist',
		'EXCEPTION.7002': 'Account is blocked',
		'EXCEPTION.701': 'Formula invalid',
		'EXCEPTION.702': 'CAN ID name invalid',
		'EXCEPTION.703': 'Condition invalid',
		'EXCEPTION.704': 'Variable name Invalid ',
		'EXCEPTION.705': 'Workstate parameter invalid',
		'EXCEPTION.706': 'Workstate invalid for implement type',
		'EXCEPTION.707': 'File creation failed',
		'EXCEPTION.800': 'ConfigValue name invalid',
		'EXCEPTION.8000': 'Employer is empty',
		'EXCEPTION.8001': 'Employee is empty',
		'EXCEPTION.8002': 'Employee not found for employer',
		'EXCEPTION.8003': 'Cost less than zero',
		'EXCEPTION.8004': 'Maximum number of  user licenses taken',
		'EXCEPTION.8005': 'Not your employer',
		'EXCEPTION.8006': 'Employee already exists',
		'EXCEPTION.8007': 'Access token is empty',
		'EXCEPTION.8008': 'Access token invalid',
		'EXCEPTION.8009': 'At least one admin has to exist in an enterprise',
		'EXCEPTION.8010': 'User can only be connected to the enterprise that created the user',
		'EXCEPTION.900': 'Does not exist',
		'EXCEPTION.9000': 'Start time is empty or in the future',
		'EXCEPTION.9001': 'Stop time is empty or in the future',
		'EXCEPTION.9002': 'Stop time is equal or less than start time',
		'EXCEPTION.9003': 'Driver is no employee of job owner',
		'EXCEPTION.9004': 'Implement does not belong to job owner',
		'EXCEPTION.9005': 'Type1 invalid',
		'EXCEPTION.9006': 'Type2 invalid',
		'EXCEPTION.9007': 'Type3 invalid',
		'EXCEPTION.9008': 'Not able to generate the job - no raw data',
		'EXCEPTION.9009': 'Owner of machine does not match the owner of the implement',
		'EXCEPTION.901': 'Already exists',
		'EXCEPTION.9010': 'Job already exists',
		'EXCEPTION.9012': 'Job is not ready',
		'EXCEPTION.9013': 'Job is marked for deletion',
		'EXCEPTION.9014': 'Job is archived - No JobLocations available',
		'EXCEPTION.9015': 'Raw data too old',
		'EXCEPTION.9016': 'At least one job is part of a task',
		'EXCEPTION.9017': 'Jobs do not match (Machine, driver, implement have to match)',
		'EXCEPTION.9018': 'Gap between jobs is too big',
		'EXCEPTION.9019': 'At least one job is part of a task',
		'EXCEPTION.902': 'Owner does not exist',
		'EXCEPTION.9020': 'No splitting times',
		'EXCEPTION.9021': 'Splitting time is not greater than start and less than stop time',
		'EXCEPTION.9022': 'No job ids for merging',
		'EXCEPTION.9023': 'At least two jobs required',
		'EXCEPTION.9024': 'Point density has to be greater zero and less than or equal one',
		'EXCEPTION.903': 'Object with the id does not exist',
		'EXCEPTION.904': 'Latitude out of range',
		'EXCEPTION.905': 'Longitude out of range',
		'EXCEPTION.906': 'Owner do not match',
		'EXCEPTION.907': 'Parameter is empty',
		'EXCEPTION.99': 'Parameter invalid',
		'EXPORT': 'Export',
		'EXPORT.FILTERED_JOBS': 'Export all filtered jobs',
		'EXPORT.JOB_DETAILS': 'Export job details',
		'EXPORT.OPERATIONS.CUSTOMER.PERIOD': 'Export all data for customer in selected period',
		'EXPORT.OPERATIONS.FIELDS.PERIOD': 'Export all data on fields in selected period',
		'EXPORT.OPERATIONS.LOCATIONS.PERIOD': 'Export all data on locations in selected period',
		'EXPORT.POINTS': 'Data points',
		'EXPORT.POLYGONS': 'Polygons',
		'EXPORT.RAW_DATA_AS_SILO': 'Export raw data of the job as SILO file',
		'EXPORT.SELECTED': 'Export selected',
		'EXPORT.SELECT_DATA': 'Please select the data which shall be included in the PDF report',
		'EXPORT.SELECT_PERIOD': 'Select period to export',
		"FERTILIZER": "Fertilizer",
		'FIELD': 'Field',
		'FIELD.ADD': 'Add field',
		'FIELD.ADD.SUCCESS': 'Field succesfully added',
		'FIELD.DEACTIVATE.QUESTION': 'Do you really want to deactivate the field?',
		'FIELD.DEACTIVATE.SUCCESS': 'Field successfully deactivated',
		'FIELD.DELETE.QUESTION': 'Do you really want to delete the field?',
		'FIELD.DELETE.SUCCESS': 'Field successfully deleted',
		'FIELD.DETAILS': 'Field details',
		'FIELD.DRAW.START': 'Draw field borders in the map now!',
		'FIELD.EDIT.SUCCESS': 'Field successfully edited',
		'FIELD.INTERPOLATE': 'Interpolate',
		'FIELD.INTERPOLATED_VALUES': 'Interpolated values',
		'FIELD.INTERPOLATION': 'Interpolation',
		'FIELD.INTERPOLATION_SETTINGS': 'Interpolation settings',
		'FIELD.INTERPOLATION_SETTINGS.FINE': 'Fine',
		'FIELD.INTERPOLATION_SETTINGS.FINE+': 'Very fine',
		'FIELD.INTERPOLATION_SETTINGS.ROUGH': 'Rough',
		'FIELD.INTERPOLATION_SETTINGS.STANDARD': 'Standard',
		'FIELD.NUMBER': 'Field number',
		'FIELD.PROCESSED': 'Processed field',
		'FIELDS': 'Fields',
		'FIELDS.ALL': 'All fields',
		'FIELDS.DEACTIVATE.FAILURE': 'Some of the fields could not be deactivated.',
		'FIELDS.DEACTIVATE.QUESTION': 'Do you really want to deactivate the fields?',
		'FIELDS.DEACTIVATE.SUCCESS': 'Fields successfully deactivated',
		'FIELDS.DELETE.FAILURE': 'Some of the fields could not be deleted.',
		'FIELDS.DELETE.QUESTION': 'Do you really want to delete the selected fields?',
		'FIELDS.DELETE.SUCCESS': 'Fields successfully deleted',
		'FIELDS.EDIT': 'Edit fields',
		'FIELDS.IMPORT': 'Import fields',
		'FIELDS.IMPORT.ASSIGN_CUSTOMER.QUESTION': 'Do you want to assign a customer to the selected fields?',
		'FIELDS.IMPORT.SHAPE': 'Please select a SHAPE file to import.',
		'FIELDS.IMPORT.SUCCESS': 'Fields succesfully imported',
		'FIELDS.MANAGEMENT': 'Fields management',
		'FIELDS.NO': 'No fields',
		'FIELDS.NOT_SELECTED': 'No fields selected',
		'FIELDS.REACTIVATE.FAILURE': 'Some of the fields could not be reactivated',
		'FIELDS.REACTIVATE.QUESTION': 'Do you really want to reactivate the selected fields?',
		'FIELDS.REACTIVATE.SUCCESS': 'Fields reactivated successfully',
		'FIELDS.SELECT': 'Select fields',
		'FIELDS.SELECTED': 'Fields selected',
		'FILE': 'File',
		'FILE.GENERATING': 'File is being generated and added to the file manager shortly',
		'FILE.GENERATING.READY': 'A new file is ready for download',
		'FILE.MANAGER': 'File manager',
		'FILE.NO_FILES': 'No existing files',
		'FILE.UPLOAD': 'Upload file',
		'FILE_TRANSFER': 'File management',
		'FILE_TRANSFER.ADD': 'Add file',
		'FILE_TRANSFER.ADD.SUCCESS': 'File succesfully added',
		'FILE_TRANSFER.CREATE': 'Add file',
		'FILE_TRANSFER.DELETE.QUESTION': 'Do you really want to delete the file?',
		'FILE_TRANSFER.DELETE.SUCCESS': 'File succesfully deleted',
		'FILE_TRANSFER.FINISHED_TASKS': 'Ready files',
		'FILE_TRANSFER.NO': 'No files',
		'FILE_TRANSFER.QUEUED_TASKS': 'Queued files',
		'FILTER': 'Filter',
		'FIRMWARE_VERSION': 'Firmware version',
		'FIRSTNAME': 'First name',
		'FORMS.FILE_TOO_LARGE': 'File is too large',
		'FORMS.NO_PASSWORD_MATCH': 'Passwords do not match!',
		'FORMS.REQUIRED': 'Required',
    	'FORMS.INVALID_EMAIL': 'Invalid email address',
		'FORMULA': 'Formula',
		'FUEL': 'Fuel',
		'FUEL.CONSUMPTION': 'Fuel consumption',
		'FUEL.CONSUMPTION.AREA': 'Fuel consumption per area',
		'FUEL.CONSUMPTION.AVERAGE': 'Average fuel consumption',
		'FUEL.CONSUMPTION.OVERALL': 'Overall fuel consumption',
		'FUEL.CONSUMPTION.TOTAL': 'Total fuel consumption',
		'FUEL.COST': 'Fuel cost',
		'FUEL.LEVEL': 'Fuel level',
		'FUEL.PRICE_PER_LITER': 'Fuel price per liter',
		'FUEL.WARNING': 'Fuel level low!',
		'GENERAL_INSPECTION': 'General inspection',
		'GEOMETRIES.UPDATE': 'Update fields and locations',
		'GEOMETRY.ADD.REGENERATION_NEEDED': 'All underlying data has to be updated to assign it correctly after adding a new geometry. Do you want to update the data now?',
		'GEOMETRY.CLICK_TO_SAVE': 'Tap the map to set the marker\'s position',
		'GPS': 'GPS',
		'GPS.GPS': 'Internal GPS',
		'GPS.LP': 'Last known position',
		'GPS.RTK': 'RTK',
		'GPS.RTK_H': 'RTK (high precision)',
		'GPS.STATUS': 'GPS status',
		'GPS_HITCH_DISTANCE.IMPLEMENT.INFO': 'For recording the machine track correctly you need to input the distance between the hitch (A) and the point of application of the implement (B). The distance is measured in cm.',
		'GPS_HITCH_DISTANCE.MACHINE.INFO': 'For recording the machine track correctly you need to input the distance between the GPS receiver (A) and the hitch of the machine (B). The distance is measured in cm.',
		'GPS_TO_HITCH_DISTANCE': 'GPS to hitch distance',
		'HARDWARE': 'Hardware',
		'HARDWARE.SETUP.PRINT_STICKER': 'Print hardware sticker',
		'HARDWARE.SETUP.PRINT_STICKER_PACKAGING': 'Print package sticker',
		'HARDWARE.SETUP.RESET_DEVICE': 'Reset device',
		'HARDWARE.SETUP.SET_SERIAL': 'Set serial',
		'HEADLAND.PASSES': 'Headland passes',
		'HELPER_MODEL_TEXT': 'Model based on input',
		'HITCH_TO_APPLICATION_DISTANCE': 'Hitch to application distance',
		'HITCH:INVALID': 'Please enter a valid numerical value (maximum one decimal place, and negative or positive values are allowed).',
		'HINT_MARKERS.SHOW': 'Show hint markers',
		'HOME': 'Welcome',
		'HOME.CONTACTREPLY1': 'Then feel free to call us at',
		'HOME.CONTACTREPLY2': 'or send us an e-mail to',
		'HOME.INTRODUCTORY_VIDEOS': 'Introductory videos',
		'HOME.NEWSINFO1': 'All news and exciting information about fleet management and machine tracking can be found on our',
		'HOME.NEWSINFO2': 'or on our',
		'HOME.PROFILEEXPLANATION': 'Under \"My Profile\" you can change your personal data, your e-mail and your password.',
		'HOME.QUESTIONSYSTEM': 'Do you have any questions about our system?',
		'HOME.TITLE': 'Welcome',
		'HOME.WELCOMEAREA': 'Welcome to your area!',
		'IDLE': 'Idle',
		'IGNORE': 'Ignore',
		'IMPLEMENT': 'Implement',
		'IMPLEMENT.ADD': 'Add implement',
		'IMPLEMENT.ADD.SUCCESS': 'Implement added successfully',
		'IMPLEMENT.CLASS': 'Implement class',
		'IMPLEMENT.DELETE.QUESTION': 'Do you really want to delete the implement?',
		'IMPLEMENT.DELETE.SUCCESS': 'Implement successfully deleted',
		'IMPLEMENT.DETAILS': 'Implement details',
		'IMPLEMENT.EDIT': 'Edit implement',
		'IMPLEMENT.EDIT.SUCCESS': 'Implement successfully edited',
		'IMPLEMENT.FIXED': 'Fixed implement',
		'IMPLEMENT.NO': 'No implement',
		'IMPLEMENT.PROCESS.0': 'No implement',
		'IMPLEMENT.PROCESS.1': 'Baling round bales',
		'IMPLEMENT.PROCESS.10': 'Rolling',
		'IMPLEMENT.PROCESS.11': 'Seeding',
		'IMPLEMENT.PROCESS.12': 'Planting',
		'IMPLEMENT.PROCESS.13': 'Fertilizing',
		'IMPLEMENT.PROCESS.14': 'Spraying',
		'IMPLEMENT.PROCESS.15': 'Irrigating',
		'IMPLEMENT.PROCESS.16': 'Mowing',
		'IMPLEMENT.PROCESS.17': 'Taking',
		'IMPLEMENT.PROCESS.18': 'Transporting',
		'IMPLEMENT.PROCESS.19': 'Sweeping',
		'IMPLEMENT.PROCESS.2': 'Baling square bales',
		'IMPLEMENT.PROCESS.20': 'Snow ploughing',
		'IMPLEMENT.PROCESS.21': 'Salt spreading',
		'IMPLEMENT.PROCESS.22': 'Hoeing',
		'IMPLEMENT.PROCESS.23': 'Fertilizing',
		'IMPLEMENT.PROCESS.24': 'Slurry pumping',
		'IMPLEMENT.PROCESS.25': 'Slurry mixing',
		'IMPLEMENT.PROCESS.26': 'Planting potatoes',
		'IMPLEMENT.PROCESS.27': 'Harvesting potatoes',
		'IMPLEMENT.PROCESS.28': 'Separating',
		'IMPLEMENT.PROCESS.29': 'Ridge forming',
		'IMPLEMENT.PROCESS.3': 'Baling wrapping',
		'IMPLEMENT.PROCESS.30': 'Haulm topping',
		'IMPLEMENT.PROCESS.31': 'Swathing',
		'IMPLEMENT.PROCESS.32': 'Harrowing',
		'IMPLEMENT.PROCESS.33': 'Harrowing',
		'IMPLEMENT.PROCESS.34': 'Chopping',
		'IMPLEMENT.PROCESS.35': 'Sweeping',
		'IMPLEMENT.PROCESS.36': 'Snow blowing',
		'IMPLEMENT.PROCESS.37': 'Moving liquid manure containers',
		'IMPLEMENT.PROCESS.38': 'Bed forming',
		'IMPLEMENT.PROCESS.39': 'Feeding',
		'IMPLEMENT.PROCESS.4': 'Wrapping bales',
		'IMPLEMENT.PROCESS.40': 'Move wood',
		'IMPLEMENT.PROCESS.41': 'Saw wood',
		'IMPLEMENT.PROCESS.42': 'Split wood',
		'IMPLEMENT.PROCESS.43': 'Tree stump milling',
		'IMPLEMENT.PROCESS.44': 'Loading bulk material',
		'IMPLEMENT.PROCESS.45': 'Loading pallets',
		'IMPLEMENT.PROCESS.46': 'Loading bales',
		'IMPLEMENT.PROCESS.47': 'CCM mills convert',
		'IMPLEMENT.PROCESS.48': 'Push',
		'IMPLEMENT.PROCESS.49': 'Front/rear weight',
		'IMPLEMENT.PROCESS.5': 'Ploughing',
		'IMPLEMENT.PROCESS.50': 'Threshing',
		'IMPLEMENT.PROCESS.51': 'Chopping',
		'IMPLEMENT.PROCESS.52': 'Baling high pressure bales',
		'IMPLEMENT.PROCESS.53': 'Unleafing',
		'IMPLEMENT.PROCESS.54': 'Planing',
		'IMPLEMENT.PROCESS.55': 'Tillage',
		'IMPLEMENT.PROCESS.56': 'Grooming',
		'IMPLEMENT.PROCESS.57': 'Assembly work',
		'IMPLEMENT.PROCESS.58': 'Entrain',
		'IMPLEMENT.PROCESS.59': 'Loading and unloading',
		'IMPLEMENT.PROCESS.6': 'Cultivating',
		'IMPLEMENT.PROCESS.60': 'Washing',
		'IMPLEMENT.PROCESS.61': 'Compacting',
		'IMPLEMENT.PROCESS.7': 'Harrowing',
		'IMPLEMENT.PROCESS.8': 'Deep loosening',
		'IMPLEMENT.PROCESS.9': 'Power harrowing',
		'IMPLEMENT.PROCESS.deadhead': 'No implement',
		'IMPLEMENT.REMOVE': 'Remove implement',
		'IMPLEMENT.RESOURCE.0': 'Undefined',
		'IMPLEMENT.RESOURCE.1': 'Fodder',
		'IMPLEMENT.RESOURCE.10': 'Manure',
		'IMPLEMENT.RESOURCE.11': 'Slurry',
		'IMPLEMENT.RESOURCE.12': 'Compost',
		'IMPLEMENT.RESOURCE.13': 'Digestate',
		'IMPLEMENT.RESOURCE.14': 'Wood chips',
		'IMPLEMENT.RESOURCE.15': 'MaisCorn',
		'IMPLEMENT.RESOURCE.16': 'Sunflower',
		'IMPLEMENT.RESOURCE.17': 'Sorghum',
		'IMPLEMENT.RESOURCE.18': 'Rye',
		'IMPLEMENT.RESOURCE.19': 'Triticale',
		'IMPLEMENT.RESOURCE.2': 'Grass silage',
		'IMPLEMENT.RESOURCE.20': 'Wheat',
		'IMPLEMENT.RESOURCE.21': 'Field bean',
		'IMPLEMENT.RESOURCE.22': 'Pea',
		'IMPLEMENT.RESOURCE.23': 'Field grass',
		'IMPLEMENT.RESOURCE.24': 'Clover grass',
		'IMPLEMENT.RESOURCE.25': 'Barley',
		'IMPLEMENT.RESOURCE.26': 'Oat',
		'IMPLEMENT.RESOURCE.27': 'Spelt',
		'IMPLEMENT.RESOURCE.28': 'Camelina',
		'IMPLEMENT.RESOURCE.29': 'Linseed',
		'IMPLEMENT.RESOURCE.3': 'Whole plant silage',
		'IMPLEMENT.RESOURCE.30': 'Rape',
		'IMPLEMENT.RESOURCE.31': 'Soybeans',
		'IMPLEMENT.RESOURCE.32': 'Catch crop',
		'IMPLEMENT.RESOURCE.33': 'Sugarbeet',
		'IMPLEMENT.RESOURCE.34': 'Potatoes',
		'IMPLEMENT.RESOURCE.35': 'Miscanthus',
		'IMPLEMENT.RESOURCE.36': 'Topinambur',
		'IMPLEMENT.RESOURCE.37': 'Vegetables',
		'IMPLEMENT.RESOURCE.38': 'Strawberries',
		'IMPLEMENT.RESOURCE.39': 'Liquid fertilizer',
		'IMPLEMENT.RESOURCE.4': 'Hay',
		'IMPLEMENT.RESOURCE.40': 'Lime',
		'IMPLEMENT.RESOURCE.41': 'Diammonphosphat',
		'IMPLEMENT.RESOURCE.42': 'Haar flour pellets, PK, K, P, KAS',
		'IMPLEMENT.RESOURCE.43': 'Urea',
		'IMPLEMENT.RESOURCE.44': 'Diesel',
		'IMPLEMENT.RESOURCE.45': 'AdBlue',
		'IMPLEMENT.RESOURCE.46': 'Ground',
		'IMPLEMENT.RESOURCE.47': 'Plant protectant',
		'IMPLEMENT.RESOURCE.48': 'Miscellaneous',
		'IMPLEMENT.RESOURCE.49': 'Water',
		'IMPLEMENT.RESOURCE.5': 'CCM',
		'IMPLEMENT.RESOURCE.50': 'Feed mix',
		'IMPLEMENT.RESOURCE.6': 'Corn',
		'IMPLEMENT.RESOURCE.7': 'Straw',
		'IMPLEMENT.RESOURCE.8': 'Corn silage',
		'IMPLEMENT.RESOURCE.9': 'Grain',
		'IMPLEMENT.TYPE': 'Implement type',
		'IMPLEMENT.TYPE.1': 'Balers / Wrappers',
		'IMPLEMENT.TYPE.10': 'Transport trailers',
		'IMPLEMENT.TYPE.10_1': 'Three-way tipper',
		'IMPLEMENT.TYPE.10_10': 'Low bed trailer',
		'IMPLEMENT.TYPE.10_11': 'Hook lift trailer',
		'IMPLEMENT.TYPE.10_12': 'Livestock trailer',
		'IMPLEMENT.TYPE.10_13': 'Semi trailer dolly',
		'IMPLEMENT.TYPE.10_14': 'Tanker/Silo trucks',
		'IMPLEMENT.TYPE.10_2': 'Body tipper',
		'IMPLEMENT.TYPE.10_3': 'Chaser bin',
		'IMPLEMENT.TYPE.10_4': 'Platform trailer',
		'IMPLEMENT.TYPE.10_5': 'Forage wagon',
		'IMPLEMENT.TYPE.10_6': 'Silage trailer',
		'IMPLEMENT.TYPE.10_7': 'Bale transport trailer',
		'IMPLEMENT.TYPE.10_8': 'Push-off trailer',
		'IMPLEMENT.TYPE.10_9': 'Liquid manure tanker',
		'IMPLEMENT.TYPE.11': 'Livestock equipment',
		'IMPLEMENT.TYPE.11_1': 'Trailed feed mixer',
		'IMPLEMENT.TYPE.11_2': 'Fodder distribution wagon',
		'IMPLEMENT.TYPE.11_3': 'Picking-up/distribution wagon',
		'IMPLEMENT.TYPE.12': 'Forestry',
		'IMPLEMENT.TYPE.12_1': 'Forest trailer',
		'IMPLEMENT.TYPE.12_2': 'Firewood saw',
		'IMPLEMENT.TYPE.12_3': 'Firewood processor',
		'IMPLEMENT.TYPE.12_4': 'Log splitter',
		'IMPLEMENT.TYPE.12_5': 'Stump grinder',
		'IMPLEMENT.TYPE.12_6': 'Forestry winch',
		'IMPLEMENT.TYPE.12_7': 'Forestry mulcher',
		'IMPLEMENT.TYPE.12_8': 'Wood chipper',
		'IMPLEMENT.TYPE.12_8_1': 'Mounted disk chipper',
		'IMPLEMENT.TYPE.12_8_2': 'Trailed disc chipper',
		'IMPLEMENT.TYPE.12_8_3': 'Mounted drum chipper',
		'IMPLEMENT.TYPE.12_8_4': 'Trailed drum chipper',
		'IMPLEMENT.TYPE.12_8_5': 'Trailed drum chipper (self propelled)',
		'IMPLEMENT.TYPE.12_9': 'Hydraulic hedge trimmer',
		'IMPLEMENT.TYPE.13': 'Municipal equipment',
		'IMPLEMENT.TYPE.13_1': 'Sweepers',
		'IMPLEMENT.TYPE.13_10': 'Path maintenance device',
		'IMPLEMENT.TYPE.13_11': 'Banquet milling machine',
		'IMPLEMENT.TYPE.13_12': 'Salt shaker - attached',
		'IMPLEMENT.TYPE.13_13': 'Loader',
		'IMPLEMENT.TYPE.13_14': 'Washing device',
		'IMPLEMENT.TYPE.13_15': 'Irrigation device',
		'IMPLEMENT.TYPE.13_16': 'Working platform',
		'IMPLEMENT.TYPE.13_17': 'Surface mulcher',
		'IMPLEMENT.TYPE.13_18': 'Outrigger front',
		'IMPLEMENT.TYPE.13_18_1': 'Cutter head',
		'IMPLEMENT.TYPE.13_18_2': 'Mulching head',
		'IMPLEMENT.TYPE.13_18_3': 'Hedge trimmer',
		'IMPLEMENT.TYPE.13_18_4': 'Clearing basket',
		'IMPLEMENT.TYPE.13_18_5': 'Rake',
		'IMPLEMENT.TYPE.13_19': 'Outrigger centre/structure',
		'IMPLEMENT.TYPE.13_19_1': 'Cutter head',
		'IMPLEMENT.TYPE.13_19_2': 'Mulching head',
		'IMPLEMENT.TYPE.13_19_3': 'Hedge trimmer',
		'IMPLEMENT.TYPE.13_19_4': 'Clearing basket',
		'IMPLEMENT.TYPE.13_19_5': 'Rake',
		'IMPLEMENT.TYPE.13_1_1': 'Front sweeper',
		'IMPLEMENT.TYPE.13_1_2': 'Rear sweeper',
		'IMPLEMENT.TYPE.13_1_3': 'Aufbau',
		'IMPLEMENT.TYPE.13_2': 'Snow plough',
		'IMPLEMENT.TYPE.13_20': 'Outrigger rear',
		'IMPLEMENT.TYPE.13_20_1': 'Cutter head',
		'IMPLEMENT.TYPE.13_20_2': 'Mulching head',
		'IMPLEMENT.TYPE.13_20_3': 'Hedge trimmer',
		'IMPLEMENT.TYPE.13_20_4': 'Clearing basket',
		'IMPLEMENT.TYPE.13_20_5': 'Rake',
		'IMPLEMENT.TYPE.13_21': 'Leaf blower',
		'IMPLEMENT.TYPE.13_22': 'Bankettverdichter / Plattenverdichter',
		'IMPLEMENT.TYPE.13_3': 'Snow plough - V-form',
		'IMPLEMENT.TYPE.13_4': 'Snow cutter blower',
		'IMPLEMENT.TYPE.13_5': 'Mounted spreader',
		'IMPLEMENT.TYPE.13_6': 'Towed spreader',
		'IMPLEMENT.TYPE.13_7': 'Roadside mower',
		'IMPLEMENT.TYPE.13_8': 'Outrigger mower',
		'IMPLEMENT.TYPE.13_9': 'Mower',
		'IMPLEMENT.TYPE.14': 'Front load equipment',
		'IMPLEMENT.TYPE.14_1': 'Bucket',
		'IMPLEMENT.TYPE.14_2': 'Bucket (high volume)',
		'IMPLEMENT.TYPE.14_3': 'Pallet fork',
		'IMPLEMENT.TYPE.14_4': 'Bale gripper',
		'IMPLEMENT.TYPE.14_5': 'Bale fork',
		'IMPLEMENT.TYPE.14_6': 'Grabbing bucket',
		'IMPLEMENT.TYPE.14_7': 'Working platform',
		'IMPLEMENT.TYPE.14_8': 'Manure fork',
		'IMPLEMENT.TYPE.15': 'Harvesting attachements',
		'IMPLEMENT.TYPE.15_1': 'Cutting',
		'IMPLEMENT.TYPE.15_1_1': 'Cutting standard',
		'IMPLEMENT.TYPE.15_1_2': 'Cutting foldable',
		'IMPLEMENT.TYPE.15_2': 'Maize picker',
		'IMPLEMENT.TYPE.15_2_1': 'Maize picker standard',
		'IMPLEMENT.TYPE.15_3': 'Corn header',
		'IMPLEMENT.TYPE.15_4': 'Whole plant silage attachment',
		'IMPLEMENT.TYPE.15_5': 'Pick-Up',
		'IMPLEMENT.TYPE.15_6': 'Clearing attachment',
		'IMPLEMENT.TYPE.15_7': 'Intake system',
		'IMPLEMENT.TYPE.15_8': 'Swath pick-up',
		'IMPLEMENT.TYPE.16': 'Miscellaneous',
		'IMPLEMENT.TYPE.16_1': 'CCM mashing mill',
		'IMPLEMENT.TYPE.16_2': 'Front weight',
		'IMPLEMENT.TYPE.16_3': 'Rear weight',
		'IMPLEMENT.TYPE.16_4': 'Pushing blade',
		'IMPLEMENT.TYPE.17': 'Orchard and vineyard',
		'IMPLEMENT.TYPE.17_1': 'Clearing plow',
		'IMPLEMENT.TYPE.17_2': 'Planting machine',
		'IMPLEMENT.TYPE.17_3': 'Defoliator',
		'IMPLEMENT.TYPE.17_4': 'Rootstock milling machine',
		'IMPLEMENT.TYPE.18': 'Vegetable growing',
		'IMPLEMENT.TYPE.18_1': 'Carrot harvester',
		'IMPLEMENT.TYPE.18_2': 'Onion harvester',
		'IMPLEMENT.TYPE.18_4': 'Bulb harvester',
		'IMPLEMENT.TYPE.18_5': 'Leek harvester',
		'IMPLEMENT.TYPE.19': 'Sugar beet technology',
		'IMPLEMENT.TYPE.19_1': 'Sugar beet harvester',
		'IMPLEMENT.TYPE.19_1_1': 'Bunker harvester',
		'IMPLEMENT.TYPE.19_1_2': 'Überladeroder',
		'IMPLEMENT.TYPE.1_1': 'Round baler',
		'IMPLEMENT.TYPE.1_2': 'Square baler',
		'IMPLEMENT.TYPE.1_3': 'Baling / wrapping combination',
		'IMPLEMENT.TYPE.1_4': 'Bale wrapper',
		'IMPLEMENT.TYPE.1_5': 'High-density baler',
		'IMPLEMENT.TYPE.2': 'Soil cultivation',
		'IMPLEMENT.TYPE.2_1': 'Plough',
		'IMPLEMENT.TYPE.2_10': 'Rotary tiller',
		'IMPLEMENT.TYPE.2_10_1': 'Rotary tiller - mounted',
		'IMPLEMENT.TYPE.2_10_2': 'Rotary tiller - attached',
		'IMPLEMENT.TYPE.2_11': 'Front packer',
		'IMPLEMENT.TYPE.2_12': 'Roller',
		'IMPLEMENT.TYPE.2_12_1': 'Roller - mounted ',
		'IMPLEMENT.TYPE.2_12_2': 'Roller - attached',
		'IMPLEMENT.TYPE.2_13': 'Rotary harrows',
		'IMPLEMENT.TYPE.2_13_1': 'Rotary harrows - mounted',
		'IMPLEMENT.TYPE.2_13_2': 'Rotary harrows - attached',
		'IMPLEMENT.TYPE.2_14': 'Rotary cultivator',
		'IMPLEMENT.TYPE.2_14_1': 'Rotary cultivator - mounted',
		'IMPLEMENT.TYPE.2_14_2': 'Rotary cultivator - attached',
		'IMPLEMENT.TYPE.2_15': 'Seedbed combination',
		'IMPLEMENT.TYPE.2_15_1': 'Seedbed combination - mounted',
		'IMPLEMENT.TYPE.2_15_2': 'Seedbed combination - attached',
		'IMPLEMENT.TYPE.2_16': 'Presses',
		'IMPLEMENT.TYPE.2_17': 'Scrapers',
		'IMPLEMENT.TYPE.2_17_1': 'Scrapers - mounted',
		'IMPLEMENT.TYPE.2_17_2': 'Scrapers - attached',
		'IMPLEMENT.TYPE.2_18': 'Straw harrow',
		'IMPLEMENT.TYPE.2_18_1': 'Straw harrow - mounted',
		'IMPLEMENT.TYPE.2_18_2': 'Straw harrow - attached',
		'IMPLEMENT.TYPE.2_19': 'Further cultivators',
		'IMPLEMENT.TYPE.2_19_1': 'Mounted further cultivators - mounted',
		'IMPLEMENT.TYPE.2_19_2': 'Further cultivators - attached',
		'IMPLEMENT.TYPE.2_1_1': 'Mounted Plough',
		'IMPLEMENT.TYPE.2_1_2': 'Semi mounted plough',
		'IMPLEMENT.TYPE.2_1_3': 'Semi mounted plough (on land)',
		'IMPLEMENT.TYPE.2_2': 'Cultivator',
		'IMPLEMENT.TYPE.2_20': 'Further cultivators',
		'IMPLEMENT.TYPE.2_2_1': 'Mounted cultivator',
		'IMPLEMENT.TYPE.2_2_2': 'Trailed cultivator',
		'IMPLEMENT.TYPE.2_3': 'Disc harrow',
		'IMPLEMENT.TYPE.2_3_1': 'Mounted disc harrow',
		'IMPLEMENT.TYPE.2_3_2': 'Trailed harrow',
		'IMPLEMENT.TYPE.2_4': 'Compact disc harrow',
		'IMPLEMENT.TYPE.2_4_1': 'Compact disc harrow - mounted',
		'IMPLEMENT.TYPE.2_4_2': 'Compact disc harrow - attached',
		'IMPLEMENT.TYPE.2_5': 'Deep loosener',
		'IMPLEMENT.TYPE.2_5_1': 'Deep loosener - mounted',
		'IMPLEMENT.TYPE.2_5_2': 'Deep loosener - attached',
		'IMPLEMENT.TYPE.2_6': 'Spading machine',
		'IMPLEMENT.TYPE.2_6_1': 'Spading machine - mounted',
		'IMPLEMENT.TYPE.2_6_2': 'Spading machine - attached',
		'IMPLEMENT.TYPE.2_7': 'Rotary harrow',
		'IMPLEMENT.TYPE.2_7_1': 'Rotary harrow - mounted',
		'IMPLEMENT.TYPE.2_7_2': 'Rotary harrow - attached',
		'IMPLEMENT.TYPE.2_8': 'Rotary hoe',
		'IMPLEMENT.TYPE.2_8_1': 'Rotary hoe  - mounted',
		'IMPLEMENT.TYPE.2_8_2': 'Rotary hoe  - attached',
		'IMPLEMENT.TYPE.2_9': 'Reciprocating harrow',
		'IMPLEMENT.TYPE.2_9_1': 'Reciprocating harrow - mounted',
		'IMPLEMENT.TYPE.2_9_2': 'Reciprocating harrow - attached',
		'IMPLEMENT.TYPE.3': 'Seeders/Planters',
		'IMPLEMENT.TYPE.3_1': 'Mechanical seeder',
		'IMPLEMENT.TYPE.3_1_1': 'Mechanical seeder - mounted',
		'IMPLEMENT.TYPE.3_1_2': 'Mechanical seeder - attached',
		'IMPLEMENT.TYPE.3_1_3': 'Mechanical  seeding combination - mounted',
		'IMPLEMENT.TYPE.3_1_4': 'Mechanical seeding combination - attached',
		'IMPLEMENT.TYPE.3_2': 'Pneumatic seeder',
		'IMPLEMENT.TYPE.3_2_1': 'Pneumatic seeder - mounted',
		'IMPLEMENT.TYPE.3_2_2': 'Pneumatic seeder - attached',
		'IMPLEMENT.TYPE.3_2_3': 'Pneumatic seeding combination - mounted',
		'IMPLEMENT.TYPE.3_2_4': 'Pneumatic seeding combination - attached',
		'IMPLEMENT.TYPE.3_3': 'Precision mechanical seeder',
		'IMPLEMENT.TYPE.3_3_1': 'Precision mechanical seeder - mounted',
		'IMPLEMENT.TYPE.3_3_2': 'Precision mechanical seeder - attached',
		'IMPLEMENT.TYPE.3_3_3': 'Precision mechanical seeding combination - mounted',
		'IMPLEMENT.TYPE.3_3_4': 'Precision mechanical seeding combination - attached',
		'IMPLEMENT.TYPE.3_4': 'Precision air seeder',
		'IMPLEMENT.TYPE.3_4_1': 'Precision air seeder - mounted',
		'IMPLEMENT.TYPE.3_4_2': 'Precision air seeder - attached',
		'IMPLEMENT.TYPE.3_4_3': 'Precision air seeding combination - mounted',
		'IMPLEMENT.TYPE.3_4_4': 'Precision air seeding combination - attached',
		'IMPLEMENT.TYPE.3_5': 'Direct seed drill',
		'IMPLEMENT.TYPE.3_5_1': 'Direct seed drill - mounted',
		'IMPLEMENT.TYPE.3_5_2': 'Direct seed drill - attached',
		'IMPLEMENT.TYPE.3_6': 'Single grain direct seed drill',
		'IMPLEMENT.TYPE.3_6_1': 'Single grain direct seed drill - mounted',
		'IMPLEMENT.TYPE.3_6_2': 'Single grain direct seed drill - attached',
		'IMPLEMENT.TYPE.3_7': 'Planter',
		'IMPLEMENT.TYPE.3_7_1': 'Planter - mounted',
		'IMPLEMENT.TYPE.3_7_2': 'Planter - attached',
		'IMPLEMENT.TYPE.3_8': 'Grass seeder',
		'IMPLEMENT.TYPE.3_8_1': 'Grassland seeder - mounted',
		'IMPLEMENT.TYPE.3_8_2': 'Grassland seeder - attached',
		'IMPLEMENT.TYPE.3_9': 'Front tank',
		'IMPLEMENT.TYPE.4': 'Spreader',
		'IMPLEMENT.TYPE.4_1': 'Spreader - mounted',
		'IMPLEMENT.TYPE.4_2': 'Spreader - attached',
		'IMPLEMENT.TYPE.5': 'Plant protection',
		'IMPLEMENT.TYPE.5_1': 'Sprayer - mounted',
		'IMPLEMENT.TYPE.5_2': 'Sprayer - attached',
		'IMPLEMENT.TYPE.5_3': 'Hoe',
		'IMPLEMENT.TYPE.5_3_1': 'Hoe - mounted',
		'IMPLEMENT.TYPE.5_3_2': 'Hoe - attached',
		'IMPLEMENT.TYPE.5_4': 'Weeder',
		'IMPLEMENT.TYPE.5_4_1': 'Weeder  - mounted',
		'IMPLEMENT.TYPE.5_4_2': 'Weeder - attached',
		'IMPLEMENT.TYPE.6': 'Manure technology',
		'IMPLEMENT.TYPE.6_1': 'Muck/compost spreader',
		'IMPLEMENT.TYPE.6_2': 'Slurry tanker',
		'IMPLEMENT.TYPE.6_2_1': 'Exact scatterer',
		'IMPLEMENT.TYPE.6_2_2': 'Drip hose boom',
		'IMPLEMENT.TYPE.6_2_3': 'Trailing shoe spreader',
		'IMPLEMENT.TYPE.6_2_4': 'Cultivator injector',
		'IMPLEMENT.TYPE.6_2_5': 'Disc harrow injector',
		'IMPLEMENT.TYPE.6_2_6': 'Disc cutter injector',
		'IMPLEMENT.TYPE.6_2_7': 'Striptill injector',
		'IMPLEMENT.TYPE.6_2_8': 'Swivel distributors',
		'IMPLEMENT.TYPE.6_3': 'Slurry pump',
		'IMPLEMENT.TYPE.6_4': 'Slurry mixer',
		'IMPLEMENT.TYPE.6_5': 'Slurry container',
		'IMPLEMENT.TYPE.6_6': 'Hose system',
		'IMPLEMENT.TYPE.6_6_1': 'Drag hose distributor',
		'IMPLEMENT.TYPE.6_6_2': 'Drag shoe distributor',
		'IMPLEMENT.TYPE.6_6_3': 'Slurry disc injector',
		'IMPLEMENT.TYPE.6_6_4': 'Slurry cultivator',
		'IMPLEMENT.TYPE.6_6_5': 'Slurry disc harrow',
		'IMPLEMENT.TYPE.6_6_6': 'Slurry injector',
		'IMPLEMENT.TYPE.6_6_7': 'Swivel distributor',
		'IMPLEMENT.TYPE.7': 'Irrigation technology',
		'IMPLEMENT.TYPE.7_1': 'Irrigation traveller',
		'IMPLEMENT.TYPE.7_2': 'Irrigation boom',
		'IMPLEMENT.TYPE.8': 'Potato equipment',
		'IMPLEMENT.TYPE.8_1': 'Potato planter',
		'IMPLEMENT.TYPE.8_1_1': 'Planter without rotary tiller',
		'IMPLEMENT.TYPE.8_1_2': 'Planter with rotary tiller',
		'IMPLEMENT.TYPE.8_1_3': 'Planter without rotary tiller - attached',
		'IMPLEMENT.TYPE.8_1_4': 'Planter with rotary tiller - mounted',
		'IMPLEMENT.TYPE.8_2': 'Potato harvester - windrower',
		'IMPLEMENT.TYPE.8_3': 'Potato harvester - with bunker',
		'IMPLEMENT.TYPE.8_4': 'Potato harvester - elevator',
		'IMPLEMENT.TYPE.8_5': 'Ridge former',
		'IMPLEMENT.TYPE.8_6': 'Separator',
		'IMPLEMENT.TYPE.8_7': 'Rotary tiller',
		'IMPLEMENT.TYPE.8_8': 'Haulm topper',
		'IMPLEMENT.TYPE.9': 'Grassland equipment',
		'IMPLEMENT.TYPE.9_1': 'Drum mower',
		'IMPLEMENT.TYPE.9_1_1': 'Drum mower with conditioner',
		'IMPLEMENT.TYPE.9_1_2': 'Drum mower without conditioner',
		'IMPLEMENT.TYPE.9_1_3': 'Drum mower with conditioner - mounted',
		'IMPLEMENT.TYPE.9_1_4': 'Drum mower without conditioner - attached',
		'IMPLEMENT.TYPE.9_2': 'Disc mower',
		'IMPLEMENT.TYPE.9_2_1': 'Disc mower with conditioner',
		'IMPLEMENT.TYPE.9_2_2': 'Disc mower without conditioner',
		'IMPLEMENT.TYPE.9_2_3': 'Disc mower with conditioner - mounted',
		'IMPLEMENT.TYPE.9_2_4': 'Disc mower without conditioner - attached',
		'IMPLEMENT.TYPE.9_3': 'Rotary tedder',
		'IMPLEMENT.TYPE.9_3_1': 'Rotary tedder - mounted',
		'IMPLEMENT.TYPE.9_3_2': 'Rotary tedder - attached',
		'IMPLEMENT.TYPE.9_4': 'Swather',
		'IMPLEMENT.TYPE.9_4_1': 'Single rotor swather',
		'IMPLEMENT.TYPE.9_4_2': 'Dual-rotor swather (side swath laying)',
		'IMPLEMENT.TYPE.9_4_3': 'Dual-rotor swather (central swath laying)',
		'IMPLEMENT.TYPE.9_4_4': 'Four-rotor swather',
		'IMPLEMENT.TYPE.9_4_5': 'Continuous merger',
		'IMPLEMENT.TYPE.9_4_6': 'Rotary rake',
		'IMPLEMENT.TYPE.9_5': 'Grassland harrow',
		'IMPLEMENT.TYPE.9_6': 'Pasture harrow',
		'IMPLEMENT.TYPE.9_7': 'Grassland roller',
		'IMPLEMENT.TYPE.9_8': 'Chopper',
		'IMPLEMENTS': 'Implements',
		'IMPLEMENTS.ALL': 'All implements',
		'IMPLEMENTS.DEACTIVATE.FAILURE': 'Some of the implements could not be deactivated.',
		'IMPLEMENTS.DEACTIVATE.QUESTION': 'Do you really want to deactivate the selected implements?',
		'IMPLEMENTS.DEACTIVATE.SUCCESS': 'Implements deactivated successfully',
		'IMPLEMENTS.DELETE.FAILURE': 'Some of the implements could not be deleted.',
		'IMPLEMENTS.DELETE.QUESTION': 'Do you really want to delete the selected implements?',
		'IMPLEMENTS.DELETE.SUCCESS': 'Implements have been deleted',
		'IMPLEMENTS.MANAGEMENT': 'Implements management',
		'IMPLEMENTS.NO': 'No implements',
		'IMPLEMENTS.NOT_SELECTED': 'No implements selected',
		'IMPLEMENTS.REACTIVATE.FAILURE': 'Some of the implements could not be reactivated.',
		'IMPLEMENTS.REACTIVATE.QUESTION': 'Do you really want to reactivate the selected implements?',
		'IMPLEMENTS.REACTIVATE.SUCCESS': 'Implements reactivated successfully',
		'IMPLEMENTS.SELECTED': 'Selected implements',
		'IMPLEMENT_SCAN_DISABLED': 'Implement beacon scan inactive',
		'IMPORT': 'Import',
		'INACTIVE': 'Inactive',
		'INDIVIDUAL_LABELING': 'Custom labeling',
		'INFO': 'Info',
		'INTERPOLATION.MAP': 'Interpolation map',
		'INTERPOLATION.MAP.SETTINGS': 'Interpolation map settings',
		'IO_BOX_ACTIVATED': 'IOBox active',
		'ISOBUS.DDI.1': 'Setpoint Volume Per Area Application Rate',
		'ISOBUS.DDI.10': 'Maximum Mass Per Area Application Rate',
		'ISOBUS.DDI.100': 'Crop Contamination',
		'ISOBUS.DDI.101': 'Setpoint Bale Width',
		'ISOBUS.DDI.102': 'Actual Bale Width',
		'ISOBUS.DDI.103': 'Default Bale Width',
		'ISOBUS.DDI.104': 'Minimum Bale Width',
		'ISOBUS.DDI.105': 'Maximum Bale Width',
		'ISOBUS.DDI.106': 'Setpoint Bale Height',
		'ISOBUS.DDI.107': 'ActualBaleHeight',
		'ISOBUS.DDI.108': 'Default Bale Height',
		'ISOBUS.DDI.109': 'Minimum Bale Height',
		'ISOBUS.DDI.11': 'Setpoint Count Per Area Application Rate',
		'ISOBUS.DDI.110': 'Maximum Bale Height',
		'ISOBUS.DDI.111': 'Setpoint Bale Size',
		'ISOBUS.DDI.112': 'Actual Bale Size',
		'ISOBUS.DDI.113': 'Default Bale Size',
		'ISOBUS.DDI.114': 'Minimum Bale Size',
		'ISOBUS.DDI.115': 'Maximum Bale Size',
		'ISOBUS.DDI.116': 'Total Area',
		'ISOBUS.DDI.117': 'Effective Total Distance',
		'ISOBUS.DDI.118': 'Ineffective Total Distance',
		'ISOBUS.DDI.119': 'Effective Total Time',
		'ISOBUS.DDI.12': 'Actual Count Per Area Application Rate',
		'ISOBUS.DDI.120': 'Ineffective Total Time',
		'ISOBUS.DDI.121': 'Product Density Mass Per Volume',
		'ISOBUS.DDI.122': 'Product Density Mass PerCount',
		'ISOBUS.DDI.123': 'Product Density Volume Per Count',
		'ISOBUS.DDI.124': 'Auxiliary Valve Scaling Extend',
		'ISOBUS.DDI.125': 'Auxiliary Valve Scaling Retract',
		'ISOBUS.DDI.126': 'Auxiliary Valve Ramp Extend Up',
		'ISOBUS.DDI.127': 'Auxiliary Valve Ramp Extend Down',
		'ISOBUS.DDI.128': 'Auxiliary Valve Ramp Retract Up',
		'ISOBUS.DDI.129': 'Auxiliary Valve Ramp Retract Down',
		'ISOBUS.DDI.13': 'Default Count Per Area Application Rate',
		'ISOBUS.DDI.130': 'Auxiliary Valve Float Threshold',
		'ISOBUS.DDI.131': 'Auxiliary Valve Progressivity Extend',
		'ISOBUS.DDI.132': 'Auxiliary Valve Progressivity Retract',
		'ISOBUS.DDI.133': 'Auxiliary Valve Invert Ports',
		'ISOBUS.DDI.134': 'Device Element Offset X',
		'ISOBUS.DDI.135': 'Device Element Offset Y',
		'ISOBUS.DDI.136': 'Device Element Offset Z',
		'ISOBUS.DDI.137': 'Device Volume Capacity',
		'ISOBUS.DDI.138': 'Device Mass Capacity',
		'ISOBUS.DDI.139': 'Device Count Capacity',
		'ISOBUS.DDI.14': 'Minimum Count Per Area Application Rate',
		'ISOBUS.DDI.140': 'Setpoint Percentage Application Rate',
		'ISOBUS.DDI.141': 'Actual Work State',
		'ISOBUS.DDI.142': 'Physical Setpoint Time Latency',
		'ISOBUS.DDI.143': 'Physical Actual Value Time Latency',
		'ISOBUS.DDI.144': 'Yaw Angle',
		'ISOBUS.DDI.145': 'Roll Angle',
		'ISOBUS.DDI.146': 'Pitch Angle',
		'ISOBUS.DDI.147': 'Log Count',
		'ISOBUS.DDI.148': 'Total Fuel Consumption',
		'ISOBUS.DDI.149': 'Fuel Consumption per Time',
		'ISOBUS.DDI.15': 'Maximum Count Per Area Application Rate',
		'ISOBUS.DDI.150': 'Fuel Consumption per Area',
		'ISOBUS.DDI.151': 'Area Per Time Capacity',
		'ISOBUS.DDI.153': 'Actual Normalized Difference Vegetative Index (NDVI)',
		'ISOBUS.DDI.154': 'Physical Object Length',
		'ISOBUS.DDI.155': 'Physical Object Width',
		'ISOBUS.DDI.156': 'Physical Object Height',
		'ISOBUS.DDI.157': 'Connector Type',
		'ISOBUS.DDI.158': 'Prescription Control State',
		'ISOBUS.DDI.159': 'Number of Sub-Units per Section',
		'ISOBUS.DDI.16': 'Setpoint Spacing Application Rate',
		'ISOBUS.DDI.160': 'Section Control State',
		'ISOBUS.DDI.161': 'Actual Condensed Work State (1-16)',
		'ISOBUS.DDI.162': 'Actual Condensed Work State (17-32)',
		'ISOBUS.DDI.163': 'Actual Condensed Work State (33-48)',
		'ISOBUS.DDI.164': 'Actual Condensed Work State (49-64)',
		'ISOBUS.DDI.165': 'Actual Condensed Work State (65-80)',
		'ISOBUS.DDI.166': 'Actual Condensed Work State (81-96)',
		'ISOBUS.DDI.167': 'Actual Condensed Work State (97-112)',
		'ISOBUS.DDI.168': 'Actual Condensed Work State (113-128)',
		'ISOBUS.DDI.169': 'Actual Condensed Work State (129-144)',
		'ISOBUS.DDI.17': 'Actual Spacing Application Rate',
		'ISOBUS.DDI.170': 'Actual Condensed Work State (145-160)',
		'ISOBUS.DDI.171': 'Actual Condensed Work State (161-176)',
		'ISOBUS.DDI.172': 'Actual Condensed Work State (177-192)',
		'ISOBUS.DDI.173': 'Actual Condensed Work State (193-208)',
		'ISOBUS.DDI.174': 'Actual Condensed Work State (209-224)',
		'ISOBUS.DDI.175': 'Actual Condensed Work State (225-240)',
		'ISOBUS.DDI.176': 'Actual Condensed Work State (241-256)',
		'ISOBUS.DDI.177': 'Actual length of cut',
		'ISOBUS.DDI.178': 'Element Type Instance',
		'ISOBUS.DDI.179': 'Actual Cultural Practice',
		'ISOBUS.DDI.18': 'Default Spacing Application Rate',
		'ISOBUS.DDI.180': 'Device Reference Point (DRP) to Ground distance',
		'ISOBUS.DDI.181': 'Dry Mass Per Area Yield',
		'ISOBUS.DDI.182': 'Dry Mass Per Time Yield',
		'ISOBUS.DDI.183': 'Yield Total Dry Mass',
		'ISOBUS.DDI.184': 'Reference Moisture For Dry Mass',
		'ISOBUS.DDI.185': 'Seed Cotton Mass Per Area Yield',
		'ISOBUS.DDI.186': 'Lint Cotton Mass Per Area Yield',
		'ISOBUS.DDI.187': 'Seed Cotton Mass Per Time Yield',
		'ISOBUS.DDI.188': 'Lint Cotton Mass Per Time Yield',
		'ISOBUS.DDI.189': 'Yield Total Seed Cotton Mass',
		'ISOBUS.DDI.19': 'Minimum Spacing Application Rate',
		'ISOBUS.DDI.190': 'Yield Total Lint Cotton Mass',
		'ISOBUS.DDI.191': 'Lint Turnout Percentage',
		'ISOBUS.DDI.192': 'Ambient temperature',
		'ISOBUS.DDI.193': 'Setpoint Product Pressure',
		'ISOBUS.DDI.194': 'Actual Product Pressure',
		'ISOBUS.DDI.195': 'Minimum Product Pressure',
		'ISOBUS.DDI.196': 'Maximum Product Pressure',
		'ISOBUS.DDI.197': 'Setpoint Pump Output Pressure',
		'ISOBUS.DDI.198': 'Actual Pump Output Pressure',
		'ISOBUS.DDI.199': 'Minimum Pump Output Pressure',
		'ISOBUS.DDI.2': 'Actual Volume Per Area Application Rate',
		'ISOBUS.DDI.20': 'Maximum Spacing Application Rate',
		'ISOBUS.DDI.200': 'Maximum Pump Output Pressure',
		'ISOBUS.DDI.201': 'Setpoint Tank Agitation Pressure',
		'ISOBUS.DDI.202': 'Actual Tank Agitation Pressure',
		'ISOBUS.DDI.203': 'Minimum Tank Agitation Pressure',
		'ISOBUS.DDI.204': 'Maximum Tank Agitation Pressure',
		'ISOBUS.DDI.205': 'SC Turn On Time',
		'ISOBUS.DDI.206': 'SC Turn Off Time',
		'ISOBUS.DDI.207': 'Wind speed',
		'ISOBUS.DDI.208': 'Wind direction',
		'ISOBUS.DDI.209': 'Relative Humidity',
		'ISOBUS.DDI.21': 'Setpoint Volume Per Volume Application Rate',
		'ISOBUS.DDI.210': 'Sky conditions',
		'ISOBUS.DDI.211': 'Last Bale Flakes per Bale',
		'ISOBUS.DDI.212': 'Last Bale Average Moisture',
		'ISOBUS.DDI.213': 'Last Bale Average Strokes per Flake',
		'ISOBUS.DDI.214': 'Lifetime Bale Count',
		'ISOBUS.DDI.215': 'Lifetime Working Hours',
		'ISOBUS.DDI.216': 'Actual Bale Hydraulic Pressure',
		'ISOBUS.DDI.217': 'Last Bale Average Hydraulic Pressure',
		'ISOBUS.DDI.218': 'Setpoint Bale Compression Plunger Load',
		'ISOBUS.DDI.219': 'Actual Bale Compression Plunger Load',
		'ISOBUS.DDI.22': 'Actual Volume Per Volume Application Rate',
		'ISOBUS.DDI.220': 'Last Bale Average Bale Compression Plunger Load',
		'ISOBUS.DDI.221': 'Last Bale Applied Preservative',
		'ISOBUS.DDI.222': 'Last Bale Tag Number',
		'ISOBUS.DDI.223': 'Last Bale Mass',
		'ISOBUS.DDI.224': 'Delta T',
		'ISOBUS.DDI.225': 'Setpoint Working Length',
		'ISOBUS.DDI.226': 'Actual Working Length',
		'ISOBUS.DDI.227': 'Minimum Working Length',
		'ISOBUS.DDI.228': 'Maximum Working Length',
		'ISOBUS.DDI.229': 'Actual Net Weight',
		'ISOBUS.DDI.23': 'Default Volume Per Volume Application Rate',
		'ISOBUS.DDI.230': 'Net Weight State',
		'ISOBUS.DDI.231': 'Setpoint Net Weight',
		'ISOBUS.DDI.232': 'Actual Gross Weight',
		'ISOBUS.DDI.233': 'Gross Weight State',
		'ISOBUS.DDI.234': 'Minimum Gross Weight',
		'ISOBUS.DDI.235': 'Maximum Gross Weight',
		'ISOBUS.DDI.236': 'Thresher Engagement Total Time',
		'ISOBUS.DDI.237': 'Actual Header Working Height Status',
		'ISOBUS.DDI.238': 'Actual Header Rotational Speed Status',
		'ISOBUS.DDI.239': 'Yield Hold Status',
		'ISOBUS.DDI.24': 'Minimum Volume Per Volume Application Rate',
		'ISOBUS.DDI.240': 'Actual (Un)Loading System Status',
		'ISOBUS.DDI.241': 'Crop Temperature',
		'ISOBUS.DDI.242': 'Setpoint Sieve Clearance',
		'ISOBUS.DDI.243': 'Actual Sieve Clearance',
		'ISOBUS.DDI.244': 'Minimum Sieve Clearance',
		'ISOBUS.DDI.245': 'Maximum Sieve Clearance',
		'ISOBUS.DDI.246': 'Setpoint Chaffer Clearance',
		'ISOBUS.DDI.247': 'Actual Chaffer Clearance',
		'ISOBUS.DDI.248': 'Minimum Chaffer Clearance',
		'ISOBUS.DDI.249': 'Maximum Chaffer Clearance',
		'ISOBUS.DDI.25': 'Maximum Volume Per Volume Application Rate',
		'ISOBUS.DDI.250': 'Setpoint Concave Clearance',
		'ISOBUS.DDI.251': 'Actual Concave Clearance',
		'ISOBUS.DDI.252': 'Minimum Concave Clearance',
		'ISOBUS.DDI.253': 'Maximum Concave Clearance',
		'ISOBUS.DDI.254': 'Setpoint Separation Fan Rotational Speed',
		'ISOBUS.DDI.255': 'Actual Separation Fan Rotational Speed',
		'ISOBUS.DDI.256': 'Minimum Separation Fan Rotational Speed',
		'ISOBUS.DDI.257': 'Maximum Separation Fan Rotational Speed',
		'ISOBUS.DDI.258': 'Hydraulic Oil Temperature',
		'ISOBUS.DDI.259': 'Yield Lag Ignore Time',
		'ISOBUS.DDI.26': 'Setpoint Mass Per Mass Application Rate',
		'ISOBUS.DDI.260': 'Yield Lead Ignore Time',
		'ISOBUS.DDI.261': 'Average Yield Mass Per Time',
		'ISOBUS.DDI.262': 'Average Crop Moisture',
		'ISOBUS.DDI.263': 'Average Yield Mass Per Area',
		'ISOBUS.DDI.264': 'Connector Pivot X-Offset',
		'ISOBUS.DDI.265': 'Remaining Area',
		'ISOBUS.DDI.266': 'Lifetime Application Total Mass',
		'ISOBUS.DDI.267': 'Lifetime Application Total Count',
		'ISOBUS.DDI.268': 'Lifetime Yield Total Volume',
		'ISOBUS.DDI.269': 'Lifetime Yield Total Mass',
		'ISOBUS.DDI.27': 'Actual Mass Per Mass Application Rate',
		'ISOBUS.DDI.270': 'Lifetime Yield Total Count',
		'ISOBUS.DDI.271': 'Lifetime Total Area',
		'ISOBUS.DDI.272': 'Lifetime Effective Total Distance',
		'ISOBUS.DDI.273': 'Lifetime Ineffective Total Distance',
		'ISOBUS.DDI.274': 'Lifetime Effective Total Time',
		'ISOBUS.DDI.275': 'Lifetime Ineffective Total Time',
		'ISOBUS.DDI.276': 'Lifetime Fuel Consumption',
		'ISOBUS.DDI.277': 'Lifetime Average Fuel Consumption per Time',
		'ISOBUS.DDI.278': 'Lifetime Average Fuel Consumption per Area',
		'ISOBUS.DDI.279': 'Lifetime Yield Total Dry Mass',
		'ISOBUS.DDI.28': 'Default Mass Per Mass Application Rate',
		'ISOBUS.DDI.280': 'Lifetime Yield Total Seed Cotton Mass',
		'ISOBUS.DDI.281': 'Lifetime Yield Total Lint Cotton Mass',
		'ISOBUS.DDI.282': 'Lifetime Threshing Engagement Total Time',
		'ISOBUS.DDI.283': 'Precut Total Count',
		'ISOBUS.DDI.284': 'Uncut Total Count',
		'ISOBUS.DDI.285': 'Lifetime Precut Total Count',
		'ISOBUS.DDI.286': 'Lifetime Uncut Total Count',
		'ISOBUS.DDI.287': 'Setpoint Prescription Mode',
		'ISOBUS.DDI.288': 'Actual Prescription Mode',
		'ISOBUS.DDI.289': 'Setpoint Work State',
		'ISOBUS.DDI.29': 'Minimum Mass Per Mass Application Rate',
		'ISOBUS.DDI.290': 'Setpoint Condensed Work State (1-16)',
		'ISOBUS.DDI.291': 'Setpoint Condensed Work State (17-32)',
		'ISOBUS.DDI.292': 'Setpoint Condensed Work State (33-48)',
		'ISOBUS.DDI.293': 'Setpoint Condensed Work State (49-64)',
		'ISOBUS.DDI.294': 'Setpoint Condensed Work State (65-80)',
		'ISOBUS.DDI.295': 'Setpoint Condensed Work State (81-96)',
		'ISOBUS.DDI.296': 'Setpoint Condensed Work State (97-112)',
		'ISOBUS.DDI.297': 'Setpoint Condensed Work State (113-128)',
		'ISOBUS.DDI.298': 'Setpoint Condensed Work State (129-144)',
		'ISOBUS.DDI.299': 'Setpoint Condensed Work State (145-160)',
		'ISOBUS.DDI.3': 'Default Volume Per Area Application Rate',
		'ISOBUS.DDI.30': 'MaximumMass Per Mass Application Rate',
		'ISOBUS.DDI.300': 'Setpoint Condensed Work State (161-176)',
		'ISOBUS.DDI.301': 'Setpoint Condensed Work State (177-192)',
		'ISOBUS.DDI.302': 'Setpoint Condensed Work State (193-208)',
		'ISOBUS.DDI.303': 'Setpoint Condensed Work State (209-224)',
		'ISOBUS.DDI.304': 'Setpoint Condensed Work State (225-240)',
		'ISOBUS.DDI.305': 'Setpoint Condensed Work State (241-256)',
		'ISOBUS.DDI.306': 'True Rotation Point X-Offset',
		'ISOBUS.DDI.307': 'True Rotation Point Y-Offset',
		'ISOBUS.DDI.308': 'Actual Percentage Application Rate',
		'ISOBUS.DDI.309': 'Minimum Percentage Application Rate',
		'ISOBUS.DDI.31': 'Setpoint Volume Per Mass Application Rate',
		'ISOBUS.DDI.310': 'Maximum Percentage Application Rate',
		'ISOBUS.DDI.311': 'Relative Yield Potential',
		'ISOBUS.DDI.312': 'Minimum Relative Yield Potential',
		'ISOBUS.DDI.313': 'Maximum Relative Yield Potential',
		'ISOBUS.DDI.314': 'Actual Percentage Crop Dry Matter',
		'ISOBUS.DDI.315': 'Average Percentage Crop Dry Matter',
		'ISOBUS.DDI.316': 'Effective Total Fuel Consumption',
		'ISOBUS.DDI.317': 'Ineffective Total Fuel Consumption',
		'ISOBUS.DDI.318': 'Effective Total Diesel Exhaust Fluid Consumption',
		'ISOBUS.DDI.319': 'Ineffective Total Diesel Exhaust Fluid Consumption',
		'ISOBUS.DDI.32': 'Actual Volume Per Mass Application Rate',
		'ISOBUS.DDI.320': 'Last loaded Weight',
		'ISOBUS.DDI.321': 'Last unloaded Weight',
		'ISOBUS.DDI.322': 'Load Identification Number',
		'ISOBUS.DDI.323': 'Unload Identification Number',
		'ISOBUS.DDI.324': 'Chopper Engagement Total Time',
		'ISOBUS.DDI.325': 'Lifetime Application Total Volume',
		'ISOBUS.DDI.326': 'Setpoint Header Speed',
		'ISOBUS.DDI.327': 'Actual Header Speed',
		'ISOBUS.DDI.328': 'Minimum Header Speed',
		'ISOBUS.DDI.329': 'Maximum Header Speed',
		'ISOBUS.DDI.33': 'Default Volume Per Mass Application Rate',
		'ISOBUS.DDI.330': 'Setpoint Cutting drum speed',
		'ISOBUS.DDI.331': 'Actual Cutting drum speed',
		'ISOBUS.DDI.332': 'Minimum Cutting drum speed',
		'ISOBUS.DDI.333': 'Maximum Cutting drum speed',
		'ISOBUS.DDI.334': 'Operating Hours Since Last Sharpening',
		'ISOBUS.DDI.335': 'Front PTO hours',
		'ISOBUS.DDI.336': 'Rear PTO hours',
		'ISOBUS.DDI.337': 'Lifetime Front PTO hours',
		'ISOBUS.DDI.338': 'Lifetime Rear PTO Hours',
		'ISOBUS.DDI.339': 'Effective Total Loading Time',
		'ISOBUS.DDI.34': 'Minimum Volume Per Mass Application Rate',
		'ISOBUS.DDI.340': 'Effective Total Unloading Time',
		'ISOBUS.DDI.341': 'Setpoint Grain Kernel Cracker Gap',
		'ISOBUS.DDI.342': 'Actual Grain Kernel Cracker Gap',
		'ISOBUS.DDI.343': 'Minimum Grain Kernel Cracker Gap',
		'ISOBUS.DDI.344': 'Maximum Grain Kernel Cracker Gap',
		'ISOBUS.DDI.345': 'Setpoint Swathing Width',
		'ISOBUS.DDI.346': 'Actual Swathing Width',
		'ISOBUS.DDI.347': 'Minimum Swathing Width',
		'ISOBUS.DDI.348': 'Maximum Swathing Width',
		'ISOBUS.DDI.349': 'Nozzle Drift Reduction',
		'ISOBUS.DDI.35': 'Maximum Volume Per Mass Application Rate',
		'ISOBUS.DDI.350': 'Function or Operation Technique',
		'ISOBUS.DDI.351': 'Application Total Volume',
		'ISOBUS.DDI.352': 'Application Total Mass',
		'ISOBUS.DDI.353': 'Total Application of Nitrogen',
		'ISOBUS.DDI.354': 'Total Application of Ammonium',
		'ISOBUS.DDI.355': 'Total Application of Phosphor',
		'ISOBUS.DDI.356': 'Total Application of Potassium',
		'ISOBUS.DDI.357': 'Total Application of Dry Matter',
		'ISOBUS.DDI.358': 'Average Dry Yield Mass Per Time',
		'ISOBUS.DDI.359': 'Average Dry Yield Mass Per Area',
		'ISOBUS.DDI.36': 'Setpoint Volume Per Time Application Rate',
		'ISOBUS.DDI.360': 'Last Bale Size',
		'ISOBUS.DDI.361': 'Last Bale Density',
		'ISOBUS.DDI.362': 'Total Bale Length',
		'ISOBUS.DDI.363': 'Last Bale Dry Mass',
		'ISOBUS.DDI.364': 'Actual Flake Size',
		'ISOBUS.DDI.365': 'Setpoint Downforce Pressure',
		'ISOBUS.DDI.366': 'Actual Downforce Pressure',
		'ISOBUS.DDI.367': 'Condensed Section Override State (1-16)',
		'ISOBUS.DDI.368': 'Condensed Section Override State (17-32)',
		'ISOBUS.DDI.369': 'Condensed Section Override State (33-48)',
		'ISOBUS.DDI.37': 'Actual Volume Per Time Application Rate',
		'ISOBUS.DDI.370': 'Condensed Section Override State (49-64)',
		'ISOBUS.DDI.371': 'Condensed Section Override State (65-80)',
		'ISOBUS.DDI.372': 'Condensed Section Override State (81-96)',
		'ISOBUS.DDI.373': 'Condensed Section Override State (97-112)',
		'ISOBUS.DDI.374': 'Condensed Section Override State (113-128)',
		'ISOBUS.DDI.375': 'Condensed Section Override State (129-144)',
		'ISOBUS.DDI.376': 'Condensed Section Override State (145-160)',
		'ISOBUS.DDI.377': 'Condensed Section Override State (161-176)',
		'ISOBUS.DDI.378': 'Condensed Section Override State (177-192)',
		'ISOBUS.DDI.379': 'Condensed Section Override State (193-208)',
		'ISOBUS.DDI.38': 'Default Volume Per Time Application Rate',
		'ISOBUS.DDI.380': 'Condensed Section Override State (209-224)',
		'ISOBUS.DDI.381': 'Condensed Section Override State (225-240)',
		'ISOBUS.DDI.382': 'Condensed Section Override State (241-256)',
		'ISOBUS.DDI.383': 'Apparent Wind Direction',
		'ISOBUS.DDI.384': 'Apparent Wind Speed',
		'ISOBUS.DDI.385': 'MSL Atmospheric Pressure',
		'ISOBUS.DDI.386': 'Actual Atmospheric Pressure',
		'ISOBUS.DDI.387': 'Total Revolutions in Fractional Revolutions',
		'ISOBUS.DDI.388': 'Total Revolutions in Complete Revolutions',
		'ISOBUS.DDI.389': 'Setpoint Revolutions specified as count per time',
		'ISOBUS.DDI.39': 'Minimum Volume Per Time Application Rate',
		'ISOBUS.DDI.390': 'Actual Revolutions Per Time',
		'ISOBUS.DDI.391': 'Default Revolutions Per Time',
		'ISOBUS.DDI.392': 'Minimum Revolutions Per Time',
		'ISOBUS.DDI.393': 'Maximum Revolutions Per Time',
		'ISOBUS.DDI.394': 'Actual Fuel Tank Content',
		'ISOBUS.DDI.395': 'Actual Diesel Exhaust Fluid Tank Content',
		'ISOBUS.DDI.396': 'Setpoint Speed',
		'ISOBUS.DDI.397': 'Actual Speed',
		'ISOBUS.DDI.398': 'Minimum Speed',
		'ISOBUS.DDI.399': 'Maximum Speed',
		'ISOBUS.DDI.4': 'Minimum Volume Per Area Application Rate',
		'ISOBUS.DDI.40': 'Maximum Volume Per Time Application Rate',
		'ISOBUS.DDI.400': 'Speed Source',
		'ISOBUS.DDI.401': 'Actual Application of Nitrogen',
		'ISOBUS.DDI.402': 'Actual application of Ammonium',
		'ISOBUS.DDI.403': 'Actual application of Phosphor',
		'ISOBUS.DDI.404': 'Actual application of Potassium',
		'ISOBUS.DDI.405': 'Actual application of Dry Matter',
		'ISOBUS.DDI.406': 'Actual Protein Content',
		'ISOBUS.DDI.407': 'Average Protein Content',
		'ISOBUS.DDI.408': 'Average Crop Contamination',
		'ISOBUS.DDI.409': 'Total Diesel Exhaust Fluid Consumption',
		'ISOBUS.DDI.41': 'Setpoint Mass Per Time Application Rate',
		'ISOBUS.DDI.410': 'Diesel Exhaust Fluid Cons. per Time',
		'ISOBUS.DDI.411': 'Diesel Exhaust Fluid Cons. per Area',
		'ISOBUS.DDI.412': 'Lifetime Diesel Exhaust Fluid Consumption',
		'ISOBUS.DDI.413': 'Lifetime Average Diesel Exhaust Fluid Consumption per Time',
		'ISOBUS.DDI.414': 'Lifetime Average Diesel Exhaust Fluid Consumption per Area',
		'ISOBUS.DDI.415': 'Actual Seed Singulation Percentage',
		'ISOBUS.DDI.416': 'Average Seed Singulation Percentage',
		'ISOBUS.DDI.417': 'Actual Seed Skip Percentage',
		'ISOBUS.DDI.418': 'Average Seed Skip Percentage',
		'ISOBUS.DDI.419': 'Actual Seed Multiple Percentage',
		'ISOBUS.DDI.42': 'Actual Mass Per Time Application Rate',
		'ISOBUS.DDI.420': 'Average Seed Multiple Percentage',
		'ISOBUS.DDI.421': 'Actual Seed Spacing Deviation',
		'ISOBUS.DDI.422': 'Average Seed Spacing Deviation',
		'ISOBUS.DDI.423': 'Actual Coefficient of Variation of Seed Spacing Percentage',
		'ISOBUS.DDI.424': 'Average Coefficient of Variation of Seed Spacing Percentage',
		'ISOBUS.DDI.425': 'Setpoint Maximum Allowed Seed Spacing Deviation',
		'ISOBUS.DDI.426': 'Setpoint Downforce as Force',
		'ISOBUS.DDI.427': 'Actual Downforce as Force',
		'ISOBUS.DDI.428': 'Loaded Total Mass',
		'ISOBUS.DDI.429': 'Unloaded Total Mass',
		'ISOBUS.DDI.43': 'Default Mass Per Time Application Rate',
		'ISOBUS.DDI.430': 'Lifetime Loaded Total Mass',
		'ISOBUS.DDI.431': 'Lifetime Unloaded Total Mass',
		'ISOBUS.DDI.432': 'Setpoint Application Rate of Nitrogen',
		'ISOBUS.DDI.433': 'Actual Application Rate of Nitrogen',
		'ISOBUS.DDI.434': 'Minimum Application Rate of Nitrogen',
		'ISOBUS.DDI.435': 'Maximum Application Rate of Nitrogen',
		'ISOBUS.DDI.436': 'Setpoint Application Rate of Ammonium',
		'ISOBUS.DDI.437': 'Actual Application Rate of Ammonium',
		'ISOBUS.DDI.438': 'Minimum Application Rate of Ammonium',
		'ISOBUS.DDI.439': 'Maximum Application Rate of Ammonium',
		'ISOBUS.DDI.44': 'Minimum Mass Per Time Application Rate',
		'ISOBUS.DDI.440': 'Setpoint Application Rate of Phosphor',
		'ISOBUS.DDI.441': 'Actual Application Rate of Phosphor',
		'ISOBUS.DDI.442': 'Minimum Application Rate of Phosphor',
		'ISOBUS.DDI.443': 'Maximum Application Rate of Phosphor',
		'ISOBUS.DDI.444': 'Setpoint Application Rate of Potassium',
		'ISOBUS.DDI.445': 'Actual Application Rate of Potassium',
		'ISOBUS.DDI.446': 'Minimum Application Rate of Potassium',
		'ISOBUS.DDI.447': 'Maximum Application Rate of Potassium',
		'ISOBUS.DDI.448': 'Setpoint Application Rate of Dry Matter',
		'ISOBUS.DDI.449': 'Actual Application Rate of Dry Matter',
		'ISOBUS.DDI.45': 'Maximum Mass Per Time Application Rate',
		'ISOBUS.DDI.450': 'Minimum Application Rate of Dry Matter',
		'ISOBUS.DDI.451': 'Maximum Application Rate of Dry Matter',
		'ISOBUS.DDI.452': 'Loaded Total Volume',
		'ISOBUS.DDI.453': 'Unloaded Total Volume',
		'ISOBUS.DDI.454': 'Lifetime loaded Total Volume',
		'ISOBUS.DDI.455': 'Lifetime Unloaded Total Volume',
		'ISOBUS.DDI.456': 'Last loaded Volume',
		'ISOBUS.DDI.457': 'Last unloaded Volume',
		'ISOBUS.DDI.458': 'Loaded Total Count',
		'ISOBUS.DDI.459': 'Unloaded Total Count',
		'ISOBUS.DDI.46': 'Setpoint Count Per Time Application Rate',
		'ISOBUS.DDI.460': 'Lifetime Loaded Total Count',
		'ISOBUS.DDI.461': 'Lifetime Unloaded Total Count',
		'ISOBUS.DDI.462': 'Last loaded Count',
		'ISOBUS.DDI.463': 'Last unloaded Count',
		'ISOBUS.DDI.464': 'Haul Counter',
		'ISOBUS.DDI.465': 'Lifetime Haul Counter',
		'ISOBUS.DDI.466': 'Actual relative connector angle',
		'ISOBUS.DDI.467': 'Actual Percentage Content',
		'ISOBUS.DDI.468': 'Soil Snow/Frozen Condtion',
		'ISOBUS.DDI.469': 'Estimated Soil Water Condtion',
		'ISOBUS.DDI.47': 'Actual Count Per Time Application Rate',
		'ISOBUS.DDI.470': 'Soil Compaction',
		'ISOBUS.DDI.472': 'Setpoint Length of Cut',
		'ISOBUS.DDI.473': 'Minimum length of cut',
		'ISOBUS.DDI.474': 'Maximum Length of Cut',
		'ISOBUS.DDI.475': 'Setpoint Bale Hydraulic Pressure',
		'ISOBUS.DDI.476': 'Minimum Bale Hydraulic Pressure',
		'ISOBUS.DDI.477': 'Maximum Bale Hydraulic Pressure',
		'ISOBUS.DDI.478': 'Setpoint Flake Size',
		'ISOBUS.DDI.479': 'Minimum Flake Size',
		'ISOBUS.DDI.48': 'Default Count Per Time Application Rate',
		'ISOBUS.DDI.480': 'Maximum Flake Size',
		'ISOBUS.DDI.481': 'Setpoint Number of Subbales',
		'ISOBUS.DDI.482': 'Last Bale Number of Subbales',
		'ISOBUS.DDI.483': 'Setpoint Engine Speed',
		'ISOBUS.DDI.484': 'Actual Engine Speed',
		'ISOBUS.DDI.485': 'Minimum Engine Speed',
		'ISOBUS.DDI.486': 'Maximum Engine Speed',
		'ISOBUS.DDI.488': 'Diesel Exhaust Fluid Tank Percentage Level',
		'ISOBUS.DDI.489': 'Maximum Diesel Exhaust Fluid Tank Content',
		'ISOBUS.DDI.49': 'Minimum Count Per Time Application Rate',
		'ISOBUS.DDI.490': 'Maximum Fuel Tank Content',
		'ISOBUS.DDI.491': 'Fuel Percentage Level',
		'ISOBUS.DDI.492': 'Total Engine Hours',
		'ISOBUS.DDI.493': 'Lifetime Engine Hours',
		'ISOBUS.DDI.494': 'Last Event Partner ID (Byte 1-4)',
		'ISOBUS.DDI.495': 'Last Event Partner ID (Byte 5-8)',
		'ISOBUS.DDI.496': 'Last Event Partner ID (Byte 9-12)',
		'ISOBUS.DDI.497': 'Last Event Partner ID (Byte 13-16)',
		'ISOBUS.DDI.498': 'Last Event Partner ID Type',
		'ISOBUS.DDI.499': 'Last Event Partner ID Manufacturer ID Code',
		'ISOBUS.DDI.5': 'Maximum Volume Per Area Application Rate',
		'ISOBUS.DDI.50': 'Maximum Count Per Time Application Rate',
		'ISOBUS.DDI.500': 'Last Event Partner ID Device Class',
		'ISOBUS.DDI.501': 'Setpoint Engine Torque',
		'ISOBUS.DDI.502': 'Actual Engine Torque',
		'ISOBUS.DDI.503': 'Minimum Engine Torque',
		'ISOBUS.DDI.504': 'Maximum Engine Torque',
		'ISOBUS.DDI.505': 'Tramline Control Level',
		'ISOBUS.DDI.506': 'Setpoint Tramline Control Level',
		'ISOBUS.DDI.507': 'Tramline Sequence Number',
		'ISOBUS.DDI.508': 'Unique A-B Guidance Reference Line ID',
		'ISOBUS.DDI.509': 'Actual Track Number',
		'ISOBUS.DDI.51': 'Setpoint Tillage Depth',
		'ISOBUS.DDI.510': 'Track Number to the right',
		'ISOBUS.DDI.511': 'Track Number to the left',
		'ISOBUS.DDI.512': 'Guidance Line Swath Width',
		'ISOBUS.DDI.513': 'Guidance Line Deviation',
		'ISOBUS.DDI.514': 'GNSS Quality',
		'ISOBUS.DDI.515': 'Tramline Control State',
		'ISOBUS.DDI.516': 'Tramline Overdosing Rate',
		'ISOBUS.DDI.517': 'Setpoint Tramline Condensed Work State 1-16',
		'ISOBUS.DDI.518': 'Actual Tramline Condensed Work State 1-16',
		'ISOBUS.DDI.519': 'Last Bale Lifetime Count',
		'ISOBUS.DDI.52': 'Actual Tillage Depth',
		'ISOBUS.DDI.520': 'Actual Canopy Height',
		'ISOBUS.DDI.521': 'GNSS Installation Type',
		'ISOBUS.DDI.522': 'Twine Bale Total Count',
		'ISOBUS.DDI.523': 'Mesh Bale Total Count',
		'ISOBUS.DDI.524': 'Lifetime Twine Bale Total Count',
		'ISOBUS.DDI.525': 'Lifetime Mesh Bale Total Count',
		'ISOBUS.DDI.526': 'Actual Cooling Fluid Temperature',
		'ISOBUS.DDI.528': 'Last Bale Capacity',
		'ISOBUS.DDI.529': 'Setpoint Tillage Disc Gang Angle',
		'ISOBUS.DDI.53': 'Default Tillage Depth',
		'ISOBUS.DDI.530': 'Actual Tillage Disc Gang Angle',
		'ISOBUS.DDI.531': 'Actual Applied Preservative Per Yield Mass',
		'ISOBUS.DDI.532': 'Setpoint Applied Preservative Per Yield Mass',
		'ISOBUS.DDI.533': 'Default Applied Preservative Per Yield Mass',
		'ISOBUS.DDI.534': 'Minimum Applied Preservative Per Yield Mass',
		'ISOBUS.DDI.535': 'Maximum Applied Preservative Per Yield Mass',
		'ISOBUS.DDI.536': 'Total Applied Preservative',
		'ISOBUS.DDI.537': 'Lifetime Applied Preservative',
		'ISOBUS.DDI.538': 'Average Applied Preservative Per Yield Mass',
		'ISOBUS.DDI.539': 'Actual Preservative Tank Volume',
		'ISOBUS.DDI.54': 'Minimum Tillage Depth',
		'ISOBUS.DDI.540': 'Actual Preservative Tank Level',
		'ISOBUS.DDI.541': 'Actual PTO Speed',
		'ISOBUS.DDI.542': 'Setpoint PTO Speed',
		'ISOBUS.DDI.543': 'Default PTO Speed',
		'ISOBUS.DDI.544': 'Minimum PTO Speed',
		'ISOBUS.DDI.545': 'Maximum PTO Speed',
		'ISOBUS.DDI.546': 'Lifetime Chopping Engagement Total Time',
		'ISOBUS.DDI.547': 'Setpoint Bale Compression Plunger Load',
		'ISOBUS.DDI.548': 'Actual Bale Compression Plunger Load',
		'ISOBUS.DDI.549': 'Last Bale Average Bale Compression Plunger Load',
		'ISOBUS.DDI.55': 'Maximum Tillage Depth',
		'ISOBUS.DDI.550': 'Ground Cover',
		'ISOBUS.DDI.551': 'Actual PTO Torque',
		'ISOBUS.DDI.552': 'Setpoint PTO Torque',
		'ISOBUS.DDI.553': 'Default PTO Torque',
		'ISOBUS.DDI.554': 'Minimum PTO Torque',
		'ISOBUS.DDI.555': 'Maximum PTO Torque',
		'ISOBUS.DDI.556': 'Present Weather Conditions',
		'ISOBUS.DDI.557': 'Setpoint Electrical Current',
		'ISOBUS.DDI.558': 'Actual Electrical Current',
		'ISOBUS.DDI.559': 'Minimum Electrical Current',
		'ISOBUS.DDI.56': 'Setpoint Seeding Depth',
		'ISOBUS.DDI.560': 'Maximum Electrical Current',
		'ISOBUS.DDI.561': 'Default Electrical Current',
		'ISOBUS.DDI.562': 'Setpoint Voltage',
		'ISOBUS.DDI.563': 'Default Voltage',
		'ISOBUS.DDI.564': 'Actual Voltage',
		'ISOBUS.DDI.565': 'Minimum Voltage',
		'ISOBUS.DDI.566': 'Maximum Voltage',
		'ISOBUS.DDI.567': 'Actual Electrical Resistance',
		'ISOBUS.DDI.568': 'Setpoint Electrical Power',
		'ISOBUS.DDI.569': 'Actual Electrical Power',
		'ISOBUS.DDI.57': 'Actual Seeding Depth',
		'ISOBUS.DDI.570': 'Default Electrical Power',
		'ISOBUS.DDI.571': 'Maximum Electrical Power',
		'ISOBUS.DDI.572': 'Minimum Electrical Power',
		'ISOBUS.DDI.573': 'Total Electrical Energy',
		'ISOBUS.DDI.574': 'Setpoint Electrical Energy per Area Application Rate',
		'ISOBUS.DDI.575': 'Actual Electrical Energy per Area Application Rate',
		'ISOBUS.DDI.576': 'Maximum Electrical Energy per Area Application Rate',
		'ISOBUS.DDI.577': 'Minimum Electrical Energy per Area Application Rate',
		'ISOBUS.DDI.578': 'Setpoint Temperature',
		'ISOBUS.DDI.579': 'Actual Temperature',
		'ISOBUS.DDI.58': 'Default Seeding Depth',
		'ISOBUS.DDI.580': 'Minimum Temperature',
		'ISOBUS.DDI.581': 'Maximum Temperature',
		'ISOBUS.DDI.582': 'Default Temperature',
		'ISOBUS.DDI.583': 'Setpoint Frequency',
		'ISOBUS.DDI.584': 'Actual Frequency',
		'ISOBUS.DDI.585': 'Minimum Frequency',
		'ISOBUS.DDI.586': 'Maximum Frequency',
		'ISOBUS.DDI.587': 'Previous Rainfall',
		'ISOBUS.DDI.588': 'Setpoint Volume Per Area Application Rate',
		'ISOBUS.DDI.589': 'Actual Volume Per Area Application Rate',
		'ISOBUS.DDI.59': 'Minimum Seeding Depth',
		'ISOBUS.DDI.590': 'Minimum Volume Per Area Application Rate',
		'ISOBUS.DDI.591': 'Maximum Volume Per Area Application Rate',
		'ISOBUS.DDI.592': 'Default Volume Per Area Application Rate',
		'ISOBUS.DDI.593': 'Traction Type',
		'ISOBUS.DDI.594': 'Steering type',
		'ISOBUS.DDI.595': 'Machine Mode',
		'ISOBUS.DDI.596': 'Cargo Area Cover State',
		'ISOBUS.DDI.597': 'Total Distance',
		'ISOBUS.DDI.598': 'Lifetime Total Distance',
		'ISOBUS.DDI.599': 'Total Distance Field',
		'ISOBUS.DDI.6': 'Setpoint Mass Per Area Application Rate',
		'ISOBUS.DDI.60': 'Maximum Seeding Depth',
		'ISOBUS.DDI.600': 'Lifetime Total Distance Field',
		'ISOBUS.DDI.601': 'Total Distance Street',
		'ISOBUS.DDI.602': 'Lifetime Total Distance Street',
		'ISOBUS.DDI.603': 'Actual Tramline Condensed Work State (17-32)',
		'ISOBUS.DDI.604': 'Actual Tramline Condensed Work State (33-48)',
		'ISOBUS.DDI.605': 'Actual Tramline Condensed Work State (49-64)',
		'ISOBUS.DDI.606': 'Actual Tramline Condensed Work State (65-80)',
		'ISOBUS.DDI.607': 'Actual Tramline Condensed Work State (81-96)',
		'ISOBUS.DDI.608': 'Actual Tramline Condensed Work State (97-112)',
		'ISOBUS.DDI.609': 'Actual Tramline Condensed Work State (113-128)',
		'ISOBUS.DDI.61': 'Setpoint Working Height',
		'ISOBUS.DDI.610': 'Actual Tramline Condensed Work State (129-144)',
		'ISOBUS.DDI.611': 'Actual Tramline Condensed Work State (145-160)',
		'ISOBUS.DDI.612': 'Actual Tramline Condensed Work State (161-176)',
		'ISOBUS.DDI.613': 'Actual Tramline Condensed Work State (177-192)',
		'ISOBUS.DDI.614': 'Actual Tramline Condensed Work State (193-208)',
		'ISOBUS.DDI.615': 'Actual Tramline Condensed Work State (209-224)',
		'ISOBUS.DDI.616': 'Actual Tramline Condensed Work State (225-240)',
		'ISOBUS.DDI.617': 'Actual Tramline Condensed Work State (241-256)',
		'ISOBUS.DDI.618': 'Setpoint Tramline Condensed Work State (17-32)',
		'ISOBUS.DDI.619': 'Setpoint Tramline Condensed Work State (33-48)',
		'ISOBUS.DDI.62': 'Actual Working Height',
		'ISOBUS.DDI.620': 'Setpoint Tramline Condensed Work State (49-64)',
		'ISOBUS.DDI.621': 'Setpoint Tramline Condensed Work State (65-80)',
		'ISOBUS.DDI.622': 'Setpoint Tramline Condensed Work State (81-96)',
		'ISOBUS.DDI.623': 'Setpoint Tramline Condensed Work State (97-112)',
		'ISOBUS.DDI.624': 'Setpoint Tramline Condensed Work State (113-128)',
		'ISOBUS.DDI.625': 'Setpoint Tramline Condensed Work State (129-144)',
		'ISOBUS.DDI.626': 'Setpoint Tramline Condensed Work State (145-160)',
		'ISOBUS.DDI.627': 'Setpoint Tramline Condensed Work State (161-176)',
		'ISOBUS.DDI.628': 'Setpoint Tramline Condensed Work State (177-192)',
		'ISOBUS.DDI.629': 'Setpoint Tramline Condensed Work State (193-208)',
		'ISOBUS.DDI.63': 'Default Working Height',
		'ISOBUS.DDI.630': 'Setpoint Tramline Condensed Work State (209-224)',
		'ISOBUS.DDI.631': 'Setpoint Tramline Condensed Work State (225-240)',
		'ISOBUS.DDI.632': 'Setpoint Tramline Condensed Work State (241-256)',
		'ISOBUS.DDI.634': 'Actual Volume per distance Application Rate',
		'ISOBUS.DDI.635': 'Default Volume per distance Application Rate',
		'ISOBUS.DDI.636': 'Minimum Volume per distance Application Rate',
		'ISOBUS.DDI.637': 'Maximum Volume per distance Application Rate',
		'ISOBUS.DDI.638': 'Setpoint Tire Pressure',
		'ISOBUS.DDI.639': 'Actual Tire Pressure',
		'ISOBUS.DDI.64': 'Minimum Working Height',
		'ISOBUS.DDI.640': 'Default Tire Pressure',
		'ISOBUS.DDI.641': 'Minimum Tire Pressure',
		'ISOBUS.DDI.642': 'Maximum Tire Pressure',
		'ISOBUS.DDI.643': 'Actual Tire Temperature',
		'ISOBUS.DDI.65': 'Maximum Working Height',
		'ISOBUS.DDI.66': 'Setpoint Working Width',
		'ISOBUS.DDI.67': 'Actual Working Width',
		'ISOBUS.DDI.68': 'Default Working Width',
		'ISOBUS.DDI.69': 'Minimum Working Width',
		'ISOBUS.DDI.7': 'Actual Mass Per Area Application Rate',
		'ISOBUS.DDI.70': 'Maximum Working Width',
		'ISOBUS.DDI.71': 'Setpoint Volume Content',
		'ISOBUS.DDI.72': 'Actual Volume Content',
		'ISOBUS.DDI.73': 'Maximum Volume Content',
		'ISOBUS.DDI.74': 'Setpoint Mass Content',
		'ISOBUS.DDI.75': 'Actual Mass Content',
		'ISOBUS.DDI.76': 'Maximum Mass Content',
		'ISOBUS.DDI.77': 'Setpoint Count Content',
		'ISOBUS.DDI.78': 'Actual Count Content',
		'ISOBUS.DDI.79': 'Maximum Count Content',
		'ISOBUS.DDI.8': 'Default Mass Per Area Application Rate',
		'ISOBUS.DDI.80': 'Application Total Volume',
		'ISOBUS.DDI.81': 'Application Total Mass',
		'ISOBUS.DDI.82': 'Application Total Count',
		'ISOBUS.DDI.83': 'Volume Per Area Yield',
		'ISOBUS.DDI.84': 'Mass Per Area Yield',
		'ISOBUS.DDI.85': 'Count Per Area Yield',
		'ISOBUS.DDI.86': 'Volume Per Time Yield',
		'ISOBUS.DDI.87': 'Mass Per Time Yield',
		'ISOBUS.DDI.88': 'Count Per Time Yield',
		'ISOBUS.DDI.89': 'Yield Total Volume',
		'ISOBUS.DDI.9': 'Minimum Mass Per Area Application Rate',
		'ISOBUS.DDI.90': 'Yield Total Mass',
		'ISOBUS.DDI.91': 'Yield Total Count',
		'ISOBUS.DDI.92': 'Volume Per Area Crop Loss',
		'ISOBUS.DDI.93': 'Mass Per Area Crop Loss',
		'ISOBUS.DDI.94': 'Count Per Area Crop Loss',
		'ISOBUS.DDI.95': 'Volume Per Time Crop Loss',
		'ISOBUS.DDI.96': 'Mass Per Time Crop Loss',
		'ISOBUS.DDI.97': 'Count Per Time Crop Loss',
		'ISOBUS.DDI.98': 'Percentage Crop Loss',
		'ISOBUS.DDI.99': 'Crop Moisture',
		'ISOBUS.DEVICE_CLASS.0': 'Not specified',
		'ISOBUS.DEVICE_CLASS.1': 'Tractor',
		'ISOBUS.DEVICE_CLASS.10': 'Irrigation',
		'ISOBUS.DEVICE_CLASS.11': 'Transport/Trailer',
		'ISOBUS.DEVICE_CLASS.12': 'Farm Yard Operations',
		'ISOBUS.DEVICE_CLASS.13': 'Powered Auxiliary Devices',
		'ISOBUS.DEVICE_CLASS.14': 'Special Crops',
		'ISOBUS.DEVICE_CLASS.15': 'Earth Work',
		'ISOBUS.DEVICE_CLASS.16': 'Skidder',
		'ISOBUS.DEVICE_CLASS.17': 'Sensor Systems',
		'ISOBUS.DEVICE_CLASS.18': '-',
		'ISOBUS.DEVICE_CLASS.19': 'Timber Harvesters',
		'ISOBUS.DEVICE_CLASS.2': 'Tillage',
		'ISOBUS.DEVICE_CLASS.20': 'Forwarders',
		'ISOBUS.DEVICE_CLASS.21': 'Timber Loaders',
		'ISOBUS.DEVICE_CLASS.22': 'Timber Processing Machines',
		'ISOBUS.DEVICE_CLASS.23': 'Mulchers',
		'ISOBUS.DEVICE_CLASS.24': 'Utility Vehicles',
		'ISOBUS.DEVICE_CLASS.25': 'Slurry/Manure Applicators',
		'ISOBUS.DEVICE_CLASS.26': 'Feeders/Mixers',
		'ISOBUS.DEVICE_CLASS.27': 'Weeders',
		'ISOBUS.DEVICE_CLASS.3': 'Secondary Tillage',
		'ISOBUS.DEVICE_CLASS.4': 'Planters/Seeders',
		'ISOBUS.DEVICE_CLASS.5': 'Fertilizers',
		'ISOBUS.DEVICE_CLASS.6': 'Sprayers',
		'ISOBUS.DEVICE_CLASS.7': 'Harvesters',
		'ISOBUS.DEVICE_CLASS.8': 'Root Harvesters',
		'ISOBUS.DEVICE_CLASS.9': 'Forage',
		"ISOBUS.ELEMENT_NUMBER": "Element number",
		'JOB.ARCHIVE.QUESTION': 'Do you really want to archive this job?',
		'JOB.ARCHIVE.SUCCESS': 'Job is going to be archived',
		'JOB.CAN_NOT_BE_DISPLAYED_COMPLETELY': 'The job can not be displayed completely. Any information above might be outdated and is going to be recomputed.',
		'JOB.CURRENT_STATUS': 'Current status',
		'JOB.DELETE.QUESTION': 'Do you really want to delete this job? All data of the job is going to be removed irreversible.',
		'JOB.DELETE.SUCCESS': 'Job is going to be deleted',
		'JOB.DETAILS': 'Job details',
		'JOB.DRIVER_IMPLEMENT': 'Delete or change driver/implement.',
		'JOB.EDIT': 'Edit job',
		'JOB.REGENERATE': 'Regenerate job',
		'JOB.REGENERATE.DRIVER': 'Update driver data',
		'JOB.REGENERATE.FIELDS': 'Update field data',
		'JOB.REGENERATE.IMPLEMENT': 'Update implement data',
		'JOB.REGENERATE.INTRO': 'If billing data for machines, implements or drivers has changed, it can be updated as well.',
		'JOB.REGENERATE.LOCATIONS': 'Update location data',
		'JOB.REGENERATE.MACHINE': 'Update machine data',
		'JOB.REGENERATE.QUESTION': 'Which data shall be updated?',
		'JOB.REGENERATE.SUCCESS': 'Job is going to be regenerated',
		'JOB.SPLIT': 'Split job',
		'JOB.SPLIT.ADD_SPLIT_TIME': 'Add split time',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO': 'For settings accurate to the second, the time slider may also be operated with the arrow buttons.',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO2': 'Add time(s) to split the job.',
		'JOB.SPLIT.NO_CHANGE': 'No change in job',
		'JOB.SPLIT.NO_SPLITS': 'No time(s) selected for splitting.',
		'JOB.UPDATE': 'Update job(s)',
		'JOB.WAITING_TIME_UNTIL_READY': 'Depending on the current status it might take a few minutes until the job can be show completely.',
		'JOBS': 'Jobs',
		'JOBS.ALL': 'All jobs',
		'JOBS.ARCHIVE.PARTIAL': 'Some jobs are archived.',
		'JOBS.ARCHIVE.QUESTION': 'Do you really want to archive the selected jobs?',
		'JOBS.ARCHIVE.SUCCESS': 'Jobs are going to be archived',
		'JOBS.CREATE_TASK': 'Create task',
		'JOBS.DELETE.QUESTION': 'Do you really want to delete the selected jobs? All data of the jobs is going to be removed irreversible.',
		'JOBS.DELETE.SUCCESS': 'Jobs are going to be deleted',
		'JOBS.DELETED.FAILURE': 'Some of the jobs could not be deleted.',
		'JOBS.EDIT': 'Edit jobs',
		'JOBS.EDIT.SUCCESS': 'Jobs are going to be edited',
		'JOBS.IN_TASK': 'Jobs in tasks',
		'JOBS.MERGE.SUCCESS': 'Jobs are going to be merged',
		'JOBS.MERGING': 'Merge jobs',
		'JOBS.NO': 'No jobs',
		'JOBS.NOT_SELECTED': 'No jobs selected',
		'JOBS.REGENERATE': 'Regenerate jobs',
		'JOBS.REGENERATE.SUCCESS': 'Jobs are going to be regenerated',
		'JOBS.SELECTED': 'Selected jobs',
		'JOBS.TASK_CREATED': 'Task successfully created',
		'JOBS.UPDATE.SUCCESS': 'Jobs are going to be updated',
		'JOBS.WITHOUT_TASK': 'Jobs without task',
		'JOBS.WITH_TASK': 'Jobs in task',
		'KILOMETERS': 'Kilometers',
		'LANGUAGE': 'Language',
		'LANGUAGE.ADD': 'Add language',
		'LANGUAGE.CODE': 'Language code',
		'LANGUAGE.DEFAULT': 'Default language',
		'LASTNAME': 'Last name',
		'LAST_ONLINE': 'Last online',
		'LAST_UPDATED': 'Last updated',
		'LATITUDE': 'Latitude',
		'LOAD.MORE': 'Load more',
		'LOADS': 'Loads',
		'LOCATION': 'Location',
		'LOCATION.ADD': 'Add location',
		'LOCATION.ADD.SUCCESS': 'Location succesfully added',
		'LOCATION.DEACTIVATE.QUESTION': 'Do you really want to deactivate the location?',
		'LOCATION.DEACTIVATE.SUCCESS': 'Location successfully deactivated',
		'LOCATION.DELETE.QUESTION': 'Do you really want to delete the location?',
		'LOCATION.DELETE.SUCCESS': 'Location successfully deleted',
		'LOCATION.DETAILS': 'Location details',
		'LOCATION.DRAW.START': 'Mark location in map now!',
		'LOCATION.EDIT.SUCCESS': 'Location successfully edited',
		'LOCATIONS': 'Locations',
		'LOCATIONS.ALL': 'All locations',
		'LOCATIONS.DEACTIVATE.FAILURE': 'Some of the locations could not be deactivated.',
		'LOCATIONS.DEACTIVATE.QUESTION': 'Do you really want to deactivate the locations?',
		'LOCATIONS.DEACTIVATE.SUCCESS': 'Locations successfully deactivated',
		'LOCATIONS.DELETE.FAILURE': 'Some of the locations could not be deleted.',
		'LOCATIONS.DELETE.QUESTION': 'Do you really want to delete the selected locations?',
		'LOCATIONS.DELETE.SUCCESS': 'Locations successfully deleted',
		'LOCATIONS.NO': 'No locations',
		'LOCATIONS.NOT_SELECTED': 'No locations selected',
		'LOCATIONS.REACTIVATE.FAILURE': 'Some of the locations could not be reactivated.',
		'LOCATIONS.REACTIVATE.QUESTION': 'Do you really want to reactivate the selected locations?',
		'LOCATIONS.REACTIVATE.SUCCESS': 'Locations reactivated successfully',
		'LOCATIONS.SELECTED': 'Selected locations',
		'LOG': 'Message log',
		'LOGIN': 'Log in',
		'LOGIN.NOT_UNLOCKED_YET': 'Not unlocked yet?',
		'LOGIN.NO_ACCOUNT_YET': 'No account yet?',
		'LOGIN.PASSWORD_FORGOTTEN': 'Password forgotten?',
		'LOGIN.REGISTER': 'Register',
		'LOGIN.REMEMBER_PASSWORD': 'Remember password',
		'LOGIN.UNLOCK': 'Unlock',
		'LOG_OUT': 'Log out',
		'LONGITUDE': 'Longitude',
		'LOST_PASSWORD.CHANGE_PASSWORD': 'Change password',
		'LOST_PASSWORD.ENTER_ACTIVATION': 'Please enter the activation code you received via email.',
		'LOST_PASSWORD.ENTER_EMAIL_HERE': 'Please enter your email here.',
		'LOST_PASSWORD.ENTER_VALID_EMAIL': 'Please enter a valid email address.',
		'MAC': 'MAC',
		'MACHINE': 'Machine',
		'MACHINE.ADD': 'Add machine',
		'MACHINE.ADD.SUCCESS': 'Machine successfully added',
		'MACHINE.DELETE.QUESTION': 'Do you really want to delete the machine?',
		'MACHINE.DELETE.SUCCESS': 'Machine succesfully deleted',
		'MACHINE.DETAILS': 'Machine details',
		'MACHINE.EDIT': 'Edit machine',
		'MACHINE.EDIT.SUCCESS': 'Machine succesfully edited',
		'MACHINE.INTERVAL.ADD': 'Add machine interval',
		'MACHINE.LIVE_STATUS': 'Machine live status',
		'MACHINE.NO': 'No machine',
		'MACHINE.RELOAD_POSITIONS': 'Reload machine positions',
		'MACHINE.STATUS': 'Machine status',
		'MACHINES': 'Machines',
		'MACHINES.ALL': 'All machines',
		'MACHINES.DEACTIVATE.FAILURE': 'Some of the machines could not be deactivated.',
		'MACHINES.DEACTIVATE.QUESTION': 'Do you really want to deactivate the selected machines?',
		'MACHINES.DEACTIVATE.SUCCESS': 'Machines deactivated successfully',
		'MACHINES.DELETE.FAILURE': 'Some of the machines could not be deleted.',
		'MACHINES.DELETE.QUESTION': 'Do you really want to delete the selected machines?',
		'MACHINES.DELETE.SUCCESS': 'Machines successfully deleted',
		'MACHINES.MANAGEMENT': 'Machines management',
		'MACHINES.NO': 'No machines',
		'MACHINES.NOT_SELECTED': 'No machines selected',
		'MACHINES.NO_ADAPTER.WARNING': 'No adapter is assigned to the vehicle. No data is recorded without an adapter.',
		'MACHINES.NO_LICENSE.WARNING': 'The machine has no attached license. Without a license no data will be recorded.',
		'MACHINES.REACTIVATE.FAILURE': 'Some of the machines could not be reactivated.',
		'MACHINES.REACTIVATE.QUESTION': 'Do you really want to reactivate the selected machines?',
		'MACHINES.REACTIVATE.SUCCESS': 'Machines reactivated successfully',
		'MACHINES.SELECTED': 'Selected machines',
		'MACHINE_COMBINATION': 'Machine combination',
		'MACHINE_IMPLEMENT': 'Machine/Implement',
		'MAC_DEVICES': 'Devices connected to a machine',
		'MAINTENANCE': 'Maintenance',
		'MAINTENANCE.AMOUNT': 'Due in/at',
		'MAINTENANCE.PERIOD': 'Maintenance period',
		'MAKE': 'Make',
		'MANURE': 'Manure',
		'MANURE.TYPE': 'Manure type',
		'MAP': 'Map',
		'MAP.SECTION': 'Map section',
		'MAP.SECTION.CHANGE': 'Change map section',
		'MARKER.ADD': 'Add new marker',
		'MARKER.EDIT.BORDERS': 'Edit borders',
		'MARKER.ENTRANCE': 'Entrance',
		'MARKER.EXIT': 'Exit',
		'MARKER.INFO': 'Info',
		'MARKER.WARN': 'Warn',
		'MAX': 'Max',
		'MAX_VALUE': 'Maximal value',
		'MERGE': 'Merge',
		'MESSAGES.NO': 'No messages',
		'MILEAGE': 'Mileage',
		'MILEAGE.INVALID': 'Mileage invalid',
		'MIN': 'Min',
		'MIN_VALUE': 'Minimal value',
		'MOBILE': 'Mobile',
		'MODE.SWITCH': 'Switch mode',
		'MODEL': 'Model',
		'MYPROFILE': 'My profile',
		'MYPROFILE.BASIC_DATA': 'Basic data',
		'MYPROFILE.BASIC_DATA.EDIT.SUCCESS': 'Your basic data has been changed',
		'NAME': 'Name',
		'NAV.ACTIVITIES': 'Activities',
		'NAV.ADMIN': 'Administration',
		'NAV.ADMIN.DASHBOARD': 'Dashboard',
		'NAV.ADMIN.INFO_VIEW': 'Admin Info',
		'NAV.ADMIN.JOB_IMPORT_VIEW': 'Job import',
		'NAV.ADMIN.JOB_VIEW': 'Job View',
		'NAV.ADMIN.USERS': 'User management',
		'NAV.CUSTOMERS': 'Customers',
		'NAV.DASHBOARD': 'Dashboard',
		'NAV.DATA_PREPARATION': 'Data preparation',
		'NAV.EMPLOYEES': 'Employees',
		'NAV.ENTERPRISE': 'Enterprise',
		'NAV.FIELDS': 'Fields',
		'NAV.FILE_TRANSFER': 'File transfer',
		'NAV.HARDWARE': 'Hardware',
		'NAV.HARDWARE_SETUP': 'Hardware setup',
		'NAV.IMPLEMENTS': 'Implements',
		'NAV.LOCATIONS': 'Locations',
		'NAV.MACHINES': 'Machines',
		'NAV.MY_SECTION': 'My section',
		'NAV.PATH_PLANNINGS': 'Path planning',
		'NAV.RETAILER': 'Retailer',
		'NAV.SETTINGS': 'Settings',
		'NAV.SETTINGS.ADAPTER': 'Adapter',
		'NAV.SETTINGS.GENERAL': 'Enterprise',
		'NAV.SETTINGS.PARTNER': 'Partner',
		'NAV.STATISTIC': 'Statistics',
		'NAV.TECH': 'TECH',
		'NAV.TRANSLATION.EDIT': 'Translation edit',
		'NAV.TRANSLATION_MANAGEMENT': 'Translation management',
		'NETWORK.ACCESS_TECHNOLOGY': 'Access Technology',
		'NETWORK.OPERATOR': 'Operator',
		'NEXT': 'Next',
		'NO': 'No',
		'NONE': 'None',
		'NOTICE': 'Notice',
		'NON_PRODUCTIVE_TIME': 'Non-productive time',
		'NON_PRODUCTIVE_TIMES': 'Non-productive times',
		'NON_PRODUCTIVE_TIMES.SEPARATOR': 'Separator for non productive time computation',
		'NOT_READ': 'Could not be read.',
		'NO_DATA': 'No data',
		'ONLY_ON': 'Only on',
		'OPACITY': 'Opacity',
		'OPERATING_HOURS': 'Operating hours',
		'OPERATING_HOURS.INVALID': 'Operating hours invalid',
		'OPERATION': 'Operation',
		'OPERATION.NOT_SELECTED': 'No operation selected',
		'OPERATION.SELECT': 'Select operation',
		'OPERATIONS': 'Operations',
		'OPERATIONS.ARRIVAL': 'Arrival',
		'OPERATIONS.CUSTOMER': 'Operations for customer',
		'OPERATIONS.FIELD': 'Operations on field',
		'OPERATIONS.FIELDS': 'Operations on fields',
		'OPERATIONS.FIELD_TIME': 'Time on field',
		'OPERATIONS.GEOMETRY': 'Geometry',
		'OPERATIONS.LOCATION': 'Operations on location',
		'OPERATIONS.LOCATIONS': 'Operations on locations',
		'OPERATIONS.NO': 'No operations',
		'OPERATIONS.PREPARATION': 'Preparation',
		'OVERRIDE.NO': 'No override',
		'PAGE': 'Page',
		'PAGE.OF': 'of',
		'PAGINATION.PER_PAGE': 'Per page',
		'PAGINATION.TOTAL': 'total',
		'PAGINATOR.FIRST_PAGE': 'First page',
		'PAGINATOR.ITEMS_PER_PAGE': 'Items per page',
		'PAGINATOR.LAST_PAGE': 'Last page',
		'PAGINATOR.NEXT_PAGE': 'Next page',
		'PAGINATOR.OF': 'of',
		'PAGINATOR.PREVIOUS_PAGE': 'Previous page',
		'PARTNER_CONNECTION': 'Partner connection',
		'PARTNER_CONNECTION.DOES_NOT_EXPIRE': 'Does not expire',
		'PARTNER_CONNECTION.EXPIRES_ON': 'Expires on',
		'PASSWORD': 'Password',
		'PASSWORD.CHANGE': 'Change password',
		'PASSWORD.CHANGE.ACTIVATE': 'Current password',
		'PASSWORD.CHANGE.SUCCESS': 'Password successfully changed',
		'PASSWORD.CONFIRM': 'Confirm new password',
		'PASSWORD.LENGTH.REQUIRED': 'The password must be at least 6 characters long',
		'PASSWORD.NEW_PASSWORD': 'New password',
		'PASSWORD.NO_MATCH': 'Password confirmation mismatch!',
		'PATH_PLANNING.ADD': 'Plan path',
		'PATH_PLANNING.ADD.SUCCESS': 'Planned path successfully added',
		'PATH_PLANNING.ANGLE': 'Angle',
		'PATH_PLANNING.ANGLE.LONGEST_SIDE': 'Longest side',
		'PATH_PLANNING.ANGLE.OPTIMAL': 'Optimal',
		'PATH_PLANNING.ANGLE.WORKING': 'Working angle',
		'PATH_PLANNING.AREA.COVERED': 'Covered area',
		'PATH_PLANNING.AREA.OVERLAP': 'Overlapped area',
		'PATH_PLANNING.AREA.UNCOVERED': 'Uncovered area',
		'PATH_PLANNING.DETAILS': 'Planned path',
		'PATH_PLANNING.GENERATE_PATH': 'Generate path',
		'PATH_PLANNING.GEOMETRY.CHANGED.QUESTION': 'The field boundary has been changed. Do you want to store the boundary as the current boundary of the field?',
		'PATH_PLANNING.NAME': 'Path planning name',
		'PATH_PLANNING.NAME.EXPLANATION': 'Give the path planning a name',
		'PATH_PLANNING.NOT_ENOUGH_DATA_EXPECTATION': 'Currently there is not enough data to compute the expected fuel consumption, CO2 consumption and cost',
		'PATH_PLANNING.SELECT.FIELD': 'Select the field you want the path to be planned for',
		'PATH_PLANNING.SEND_TO_MACHINE': 'Send to machine',
		'PATH_PLANNING.SETTINGS.CHANGED.QUESTION': 'The settings have been changed after generating the currently shown planned path and will not be reflected when saved. Do you want to continue?',
		'PATH_PLANNING.SUBDIVIDE': 'Subdivide field',
		'PATH_PLANNINGS.DEACTIVATE.FAILURE': 'Some of the planned paths could not be deactivated',
		'PATH_PLANNINGS.DEACTIVATE.QUESTION': 'Do you really want to deactivate the planned path?',
		'PATH_PLANNINGS.DEACTIVATE.SUCCESS': 'Planned paths have been deactivated',
		'PATH_PLANNINGS.DELETE.FAILURE': 'Some of the planned paths could not be deleted',
		'PATH_PLANNINGS.DELETE.QUESTION': 'Do you really want to delete the planned path?',
		'PATH_PLANNINGS.DELETE.SUCCESS': 'Planned paths deleted successfully',
		'PATH_PLANNINGS.MANAGEMENT': 'Planned paths management',
		'PATH_PLANNINGS.NOT_SELECTED': 'No planned path selected',
		'PATH_PLANNINGS.REACTIVATE.FAILURE': 'Some of the planned paths could not be reactivated',
		'PATH_PLANNINGS.REACTIVATE.QUESTION': 'Do you really want to reactivate the selected planned paths?',
		'PATH_PLANNINGS.REACTIVATE.SUCCESS': 'Planned paths reactivated successfully',
		'PATTERN': 'Pattern',
		'PATTERN.END_AT_ENTRANCE': 'End at entrance',
		'PATTERN.START': 'Pattern start/end',
		'PATTERN.START_AT_ENTRANCE': 'Start at entrance',
		'PAUSE': 'Pause',
		'PERFORMANCE.AVERAGE': 'Average performance',
		'PERFORMANCE.AVERAGE.EXPLAINATION': 'This value also takes all working states into account, including preparation and road times',
		'PERFORMANCE.AVERAGE.FIELD': 'Average performance (field)',
		'PERFORMANCE.AVERAGE.FIELD.EXPLAINATION': 'This value only takes working on a field, waiting on a field and turning on a field into account',
		'PERFORMANCE.TOTAL': 'Total performance',
		'PHONE': 'Contact phone',
		'PHONE.INVALID': 'Phone invalid',
		'PHONE_MOBILE': 'Phone (mobile)',
		'PH_VALUE': 'PH value',
		"PLANT_PROTECTANT": "Plant protectant",
		'PLAY': 'Play',
		"POI": "Point of interest",
		"POI.ADD": "Add point of interest",
		'POSTCODE': 'Postcode',
		'PREVIOUS': 'Previous',
		'PROCESS': 'Process',
		'PROCESSED': 'Processed',
		'PROCESSED.FAILURE': 'Failure while processing',
		'PROCESSED.SUCCESSFULL': 'Successfully processed',
		'PRODUCT': 'Product',
		'PROGRESS': 'Progress',
		'PROJECTION': 'Projection',
		'RAW_DATA': 'Raw data',
		'RECEIVED.AT': 'Received at',
		'REGENERATE': 'Regenerate',
		'REGENERATE.SELECTED': 'Regenerate selected',
		'REGISTER': 'Register',
		'REGISTER.ALREADY_REGISTERED?': 'Already registered?',
		'REGISTER.I_ACCEPT_THE': 'I accept the',
		'RELOAD': 'Reload',
		'REMOVE': 'Remove',
		'RENEW': 'Renew',
		'REOCURRING': 'Reocurring',
		'REPORT': 'Report',
		'RESET': 'Reset',
		'RESOLUTION': 'Resolution',
		'RESTORE.DRIVER': 'Restore driver',
		'RESTORE.IMPLEMENT': 'Restore implement',
		'ROAD': 'Road',
		'ROLE': 'Role',
		'RUNTIME_H': 'Runtime in h',
		'SAFETY_CHECK': 'Satefy check',
		'SATELITE': 'Satellite',
		'SAVE': 'Save',
		'SCALE.TYPE': 'Scale type',
		'SEARCH': 'Search',
		'SEASON_YEAR': 'Season',
		'SEASON_YEAR.START': 'Season start',
		'SELECT.ALL': 'Select all',
		'SELECT.CLEAR': 'Remove selection',
		'SELECT.FIELD': 'Select field',
		'SENSORDATA': 'Sensor data',
		'SENSORDATA.DESCRIPTION': 'Visualisation of sensordata',
		'SENSORDATA.SELECT_SENSOR': 'Select sensor',
		'SENSORDATA.SHOW_WORKSTATE_COLORS': 'Show workstate colors',
		'SENSOR_PARAMETER': 'Sensor parameter',
		'SENSOR_PARAMETER.ADD': 'Add sensor parameter',
		'SENSOR_PARAMETER.DEFINE_FOR_IMPLEMENT': 'Define individual sensor paremters for the selected implement.',
		'SENSOR_PARAMETER.DEFINE_INDIVIDUAL_PARAM': 'Define your individual sensor parameter.',
		'SENSOR_PARAMETER.INDIVIDUAL_SENSOR_PARAM': 'Individual sensor parameter',
		'SENSOR_PARAMETER.NOT_REMOVABLE_USED_IN_OTHER_PARAMETER': 'Sensor parameter is used in another parameter configuration',
		'SENSOR_PARAMETERS': 'Sensor parameters',
		'SENSOR_PARAMETERS.NO': 'No sensor parameters',
		'SERIAL': 'Serial number',
		'SETTINGS': 'Settings',
		'SETTINGS.ADDITIONAL': 'Additional settings',
		'SETTINGS.ADVANCED': 'Advanced settings',
		'SETTINGS.AGRIROUTER_CAN_BE_CONNECTED': 'Your Agrirouter account can be connected to exatrek to share data.',
		'SETTINGS.AGRIROUTER_CONNECTED_AND_READY': 'Agrirouter is connected and ready to use. The connection is valid until',
		'SETTINGS.CONNECTION_TO_PARTNERS': 'Connection to exatrek partners',
		'SETTINGS.FARMNET_FIELD_SYNC': 'Synchronize fields from 365Farmnet to exatrek',
		'SETTINGS.FARMNET_IMPLEMENT_SYNC': 'Synchronize implements from 365Farmnet to exatrek',
		'SETTINGS.FARMNET_MACHINE_SYNC': 'Synchronize machines from 365Farmnet to exatrek',
		'SETTINGS.GO_TO_FARMNET': 'Go to 365Farmnet',
		'SETTINGS.ONLY_FARMNET_WEBAPP': 'The synchronization from and to 365farmnet can only be used from in the 365farmnet webapp',
		'SHOW': 'Show',
		'SHOW_DIRECTION': 'Show directions',
		'SHOW_EVENTS': 'Show events',
		'SHOW_FIELDS': 'Show fields',
		'SHOW_LOCATIONS': 'Show locations',
		'SHOW_OFFLINE_MACHINES': 'Show offline machines',
		'SHOW_TRACKS': 'Show tracks',
		'SHOW_TRACKS_': 'Tracks',
		'SNACKBAR.DAYS': 'days',
		'SNACKBAR.LICENSE_EXPIRATION_WARNING': 'Your license expires in',
		'SNACKBAR.MACHINE_ONLINE_WARNING': 'At least one machine has not been online for some time!',
		'SORT_BY': 'Sort by',
		'SPEED': 'Speed',
		'SPEED.AVERAGE': 'Average speed',
		'SPEED.FASTER': 'Faster',
		'SPEED.RESET': 'Reset speed',
		'SPEED.SIGNAL.OVERRIDE': 'Speed signal override',
		'SPEED.SLOWER': 'Slower',
		'SPEED.WORKING': 'Working speed',
		'SPLIT': 'Split',
		'START': 'Start',
		'STATISTICS': 'Statistics',
		'STATUS': 'Status',
		'STOP': 'Stop',
		'STORAGE': 'Storage',
		'STORAGE.USB': 'USB storage',
		'STORAGE.USB.USED': 'USB storage used',
		'STORAGE.USED': 'Storage used',
		'SYMBOLIZATION': 'Symbolization',
		'TASK': 'Task',
		'TASK.ADDABLE_JOBS': 'Addable jobs',
		'TASK.ADD_JOBS': 'Add jobs to task',
		'TASK.ARCHIVED_JOB_WARNING': 'This task contains archived jobs and will not be shown in full!',
		'TASK.DELETE.JOB.FAILURE': 'A task has to contain at least one job!',
		'TASK.DELETE.JOB.QUESTION': 'Do you really want to delete job of the task?',
		'TASK.DELETE.JOB.SUCCESS': 'Job successfully deleted from task',
		'TASK.DELETE.QUESTION': 'Do you really want to delete the task?',
		'TASK.DELETE.SUCCESS': 'Task deleted successfully',
		'TASK.EDIT': 'Edit task',
		'TASK.EDIT.SUCCESS': 'Task edited successfully',
		'TASK.EXPORT_DETAILS': 'Export the selected task',
		'TASK.JOBS_TO_ADD': 'Jobs to be added',
		'TASK.NEW': 'New task',
		'TASKS': 'Tasks',
		'TASKS.NO': 'No tasks',
		'TASK_CONTROLLER.ACTIVE': 'TaskController (DataLog) active',
		'TASK_CONTROLLER.COMPAT_ACTIVE': 'TaskController compatibility mode active',
		'TAX_ID': 'Tax ID',
		'TC': 'TaskController',
		'TC.ACTIVE': 'TC active',
		'TC.TC_COMP': 'TC comp.',
		'TERMINAL.NO': 'No terminal',
		'TERMINAL.TYPE': 'Terminal type',
		'TEST.SUCCESS': 'Request successfull. You will receive an email soon.',
		'TIME': 'Time',
		'TIME.REMAINING': 'Remaining time',
		'TIMEZONE': 'Timezone',
		'TITLE': 'Request Test-Account',
		'TOKEN': 'Access code',
		'TOTAL': 'Total',
		'TRACKS.LOADING': 'Loading tracks...',
		'TRACK.WIDTH': 'Track width',
		'TRACK.WIDTH.NARROW': 'Narrow',
		'TRACK.WIDTH.NORMAL': 'Normal',
		'TRACK.WIDTH.WIDE': 'Wide',
		'TRACK_LENGTH': 'Track length',
		'TRACK_REPLAY': 'Track replay',
		'TRANSLATABLE': 'Translatable',
		'TRANSLATABLE.ADD': 'Add translatable',
		'TRANSLATION': 'Translation',
		'TRANSPORT': 'Transport',
		'TRANSPORT/AXLES': 'Transport/Axles',
		'TRANSPORTAMOUNT_AXLES': 'Transportamount/Axles',
		'TURNINGS': 'Turnings',
		'TURNING_OFFSET': 'Turning offset',
		'TURNING_RADIUS': 'Turning radius',
		'TYPE': 'Type',
		'UNDO': 'Undo',
		'UNIT': 'Unit',
		'UNKNOWN': 'Unknown',
		'UNTIL': 'until',
		'UPLOAD': 'Upload',
		'UPLOAD.FINISHED': 'Upload finished',
		'UPLOADING': 'Uploading',
		'USER.EDIT.SUCCESS': 'User successfully edited',
		'USERNAME': 'Username',
		'USERNAME.LENGTH.REQUIRED': 'The username must be at least 6 characters long.',
		'USERNAME.TAKEN': 'This name is already taken.',
		'USERNAME.VALID.CHARS': 'The username may only contain letters, numbers, \"-\" and \"_\".',
		'USERROLE': 'User role',
		'USERSTATUS': 'User status',
		'USER_CREATED': 'User created.',
		'WAITING': 'Waiting',
		'WARNING': 'Warning',
		'WEEK.CURRENT': 'Current week',
		'WEEK.NEXT': 'Next week',
		'WEEK.PREVIOUS': 'Previous week',
		'WEEK.SELECTED': 'Selected week',
		'WEIGHING': 'Weighing',
		'WIDTH.INVALID': 'Width invalid',
		'WORKING_HOURS': 'Working hours',
		'WORKING_TIME': 'Working time',
		'WORKING_WIDTH': 'Working width',
		'WORKSTATE': 'Workstate',
		'WORKSTATES': 'Workstates',
		'YES': 'Yes',
    'NO_POSITION_MACHINE_FOUND': 'No position machine finded',
	}
};
